import history from '../../../../history';
import { extractDataFromArray, extractNameFromArray, showFormatedDate, showFormattedTime, showFormatedDateandTime, alertConfirmation, showErrorMessage, ABCSPECTRUM } from '../../../../actions/utilAction';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { createClaimAction, getAppointmentById, getMasterData, getSoapAction, saveEncounterSigns, savePatientSoapExtensionAction, updateServiceCodeBlockedUnits, saveClockInTimeIntoAppointment, saveClockOutTimeIntoAppointment,savePatientSoapAction, generateNarrativeSummary, clearNarrativeSummary} from './actions/soapActions';
import { getPatientProfileDetails } from '../../../patients/actions/PatientActions';
import React, { Component } from 'react';
import { renderTextArea, renderCheckBox, renderTimePicker, renderTextField, renderCustomRadioButtons } from '../../../../components/reduxFields';
import { CancelButton, CommonButton } from '../../../../components/buttons';
import { getAppConfigList, getGeoLocation, getGeoLocationClockIn, getGeoLocationClockOut } from '../../../AppConfig/actions';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import classNames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import PatientInfo from '../../../patients/patient_info';
import ProblemModal from './soap_daignosisModal';
import CPTModal from './soap_CPTModal';
import SignatureWithRenderingProviderModal from './signatureWithRenderingProvider_modal';
import SignatureModal from './signature_modal';
import Alert from 'react-s-alert';
import UploadDocumentModal from '../../UploadDocument_Modal';
import { RaisedButton } from 'material-ui';
import Tooltip from 'material-ui/internal/Tooltip';
import ConfirmationPopUpModal from '../confirmationPopUpModal'
import { delay } from 'lodash';

//const validateNotes = (value) => !value ? 'Please enter notes.' : undefined;
const validateTypeOfObservation = (value) => !(value ? Number.isInteger(value.TypeOfObservation) : value) ? 'Please select type of observation' : undefined;
const validatePeoplePresentParticipate = (value) => !(value ? value.trim() : value) ? 'Please enter notes' : undefined;
const validateSettingEventReported = (value) => !(value ? value.trim() : value) ? 'Please enter notes' : undefined;
const validateAtypicalBehaviorsReported = (value) => !(value ? value.trim() : value) ? 'Please enter notes' : undefined;
const validateClientResponseToSignificantOthers = (value) => !(value ? value.trim() : value) ? 'Please enter notes' : undefined;
const validateNarrativeSummary = (value) => !(value ? value.trim() : value) ? 'Please enter notes' : undefined;
const validateProgressTowardsGoals = (value) => !(value ? Number.isInteger(value.ProgressTowardsGoals) : value) ? 'Please select progress towards goals and outcome of treatment' : undefined;

const validateOtherNotes = (value) => !(value ? value.trim() : value) ? 'Please enter other' : undefined;
const validateOtherEvidenceBasedPracticesNotes = (value) => !(value ? value.trim() : value) ? 'Please enter other' : undefined;
const validateOtherBarriersToTreatmentNotes = (value) => !(value ? value.trim() : value) ? 'Please enter other' : undefined;
const validateOtherNextStepsNotes = (value) => !(value ? value.trim() : value) ? 'Please enter other' : undefined;
const validateOtherRestrictedPatternsOfBehaviorNotes = (value) => !(value ? value.trim() : value) ? 'Please enter other' : undefined;
const validateOtherSocialCommunicationNotes = (value) => !(value ? value.trim() : value) ? 'Please enter other' : undefined;

class SessionNotes_BT_Default extends Component {
  constructor(props) {
    //console.log("hello------------->")
    super(props);
    this.state = ({
      FormProps:null,
      openRenderModal: false,
      reasonCodeState:"",
      isClockInClockOutMandate:false,
      showClockInClockOut:false,
      soapNoteDataFromModal:null,
      fixedHeader: true,
      height: '200px',
      selectable: false,
      fixedFooter: false,
      DateTimeOfVisit: '',
      patientObj: [],
      master_data: props.master_data,
      firstName: '',
      middleName: '',
      lastName: '',
      fullName: '',
      patient_id: null,
      apptid: parseInt(props.match.params.apptId, 10),
      encounterId: parseInt(props.match.params.encId, 10),
      isAdminUpdateAfterRendered: parseInt(props.match.params.isAdminUpdate, 10),
      isGenerateClaimAfterRendered: parseInt(props.match.params.isGenerateClaim, 10),
      staffID: null,
      appointmentDate: '',
      appointmentTime: '',
      staffName: '',
      patientName: '',
      appointmentTypeName: '',
      appointmentTypeIsBillable: false,
      serviceFacility: '',
      isDirectService: false,
      genderID: null,
      diagnosisArray: [],
      PatientLocationID: null,
      PatientLocationName: '',
      open: false,
      openCPT: false,
      openSign: false,
      soapPage: false,
      attachment: [],
      icdArray: [],
      DateOfService: '',
      master_CPT: props.master_data.masterCPT ? props.master_data.masterCPT : [],
      attachedDiagnosisArray: [],
      get_soap: null,
      serviceStartTime: '',
      serviceEndTime: '',
      appointment: null,
      ParentAppointmentID: null,
      appointmentStartDateTime: '',
      appointmentEndDateTime: '',
      CPTTableData: [],
      EmployeeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      signRequired: {
        employee_sign: false,
        client_sign: false,
        guardian_sign: false,
        rederingProvider_sign: false,
      },
      showCompleteButton: false,
      isAllSigned: false,
      isSoapCompleted: false,
      signatureStaffs: [],
      // isAdminUpdateAfterRendered: false,

      // checkbox handling
      isEvvPayer:false,
      isWhoWasPresentInSessionAllowed: true,
      isGoalsForSessionAllowed: true,
      isDomainsAddressedAllowed: true,
      isEvidenceBasedPracticesAllowed: true,
      TypeOfObservation: 0,
      isRestrictedPatternsOfBehaviorAllowed: true,
      isSocialCommunicationInteractionAllowed: true,      
      isBarriersToTreatmentAllowed: true,     
      ProgressTowardsGoals: 0, 
      isWhatAreTheNextStepsAllowed: true, 
      isDataCollectionEnabledForAgency : false,
      patientSessionNotesSkillsAcquisitionDataArr: [],
      patientSessionNotesBehaviorReductionDataArr: [],
      renderingProviderName: '',
      timeDifference: 0.0,
      clockInDateTime: '',
      clockOutDateTime: '',
      claimRenderingProvider: '',
      isSavedAsDraft : false,
      IsHideOnlyCompleteButton: false,
      isFormSubmitted: false,
      isServiceTimeOver: false,
      RestrictSignaturesBeforeAppointmentEndTime: false,
      openUploadDocument: false,
      uploadDocumentObj: null,
      isSessionPending: false,
      isTooltipVisible: false,
      selectedCheckBoxes : {
        BehaviorTechnician : false,
        Parent : false,
        MidLevelSupervisor : false,
        BCBA : false,
        Other : false
      },
      TextFormFields : {
        PeoplePresentParticipate: '',
        SettingEventReported : '',
        AtypicalBehaviorsReported: '',
        ClientResponseToSignificantOthers: '',
      },
      GoalsForSessionCheckboxes : {
        BuildRapport : false,
        SkillAcquisitionGoals : false,
        GeneralizationOfSkillsOrBehaviors : false,
        MaintenanceGoals : false,
        DecreasingMaladaptiveBehaviors : false,
      },
      DomainAddressedCheckboxes : {
        Behavior :false,
        Communication : false,
        ExecutiveFunctioning : false,
        SocialSkills : false,
        AdaptiveSkills : false,
        CommunityOrSafetySkills : false,
      },
      EvidenceBasedPracticesCheckboxes : {
        AntecedentBasedIntervention: false,
        DifferentialReinforcement : false,
        DiscreteTrialTeaching : false,
        Extinction : false,
        FunctionalCommunicationTraining : false,
        Modeling : false,
        IncidentalTeaching : false,
        PivotalResponseTraining : false,
        Prompting : false,
        Reinforcement : false,
        ResponseInterruptionAndRedirection : false,
        SocialSkillsTraining : false,
        TaskAnalysis : false,
        TimeDelay : false,
        Shaping : false,
        VisualSupports : false,
        OtherEvidenceBasedPractices : false,
      },
      DSMRestrictedPatternOfBehaviorCheckboxes : {
        Motorstereotypies : false,
        Stereotypieswithobjects : false,
        EcholaliaAndIdiosyncraticSpeech : false,
        ExtremeDistressAtSmallChange : false,
        DifficultiesWithTransition : false,
        RigidGreetingRituals : false,
        StrongAttachmentsToPreoccupation : false,
        ExcessivelyCircumscribedOrPerseverativeInterests : false,
        ApparentIndifferenceToPainOrTemperature : false,
        AdverseResponseToSpecificSights : false,
        VisualFascinationWithLightsOrMovement : false,
        OtherRestrictedPatternsOfBehavior : false
      },
      DSMSocialCommunicationCheckboxes : {
        SharingOfInterests : false,
        RespondingToSocialInteractions : false,
        InitiatingSocialInteractions : false,
        BackAndForthConversations : false,
        SocialApproach : false,
        NonverbalCommunication : false,
        IntegratingNonverbalAndVerbalCommunication : false,
        EyeContactAndBodyLanguage : false,
        FacialExpression : false,
        UnderstandingAndUseOfGestures : false,
        SharingImaginativePlay : false,
        MakingFriends : false,
        IncreasingInterestInPeer : false,
        OtherSocialCommunication : false,
      },
      BarriersToCommunicationCheckboxes : {
        Inattentiveness : false,
        Hyperactivity : false,
        HighRateOfMaladaptiveBehaviors : false,
        ScrollingResponses : false,
        RatioStrain : false,
        ReinforcerDependent : false,
        PromptDependence : false,
        HighRateOfSelfStimulatoryBehavior : false,
        MotivationWeakenedByResponseRequirement : false,
        SensoryDefensiveness : false,
        ObsessiveCompulsiveBehavior : false,
        OtherBarriersToTreatment : false
      },
      NextStepsCheckboxes : {
        ContinueWithProgramming : false,
        MakeModificationToBehaviorIntervention : false,
        OtherNextSteps : false
      },
      narrativeAISummaryResponse: null,
      narrativeAISummaryError: null,
      isGeneratingNarrativeSummary: false,
    });
    this.filter = {
      isClientSigned: false,
      isEmployeeSigned: false,
      isGuardianSigned: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.renderDiagnosis = this.renderDiagnosis.bind(this);
    this.renderCpt = this.renderCpt.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCompleteSoap = this.onCompleteSoap.bind(this);
    this.changeIsTypeOfObservation = this.changeIsTypeOfObservation.bind(this);
    this.changeIsProgressTowardsGoals = this.changeIsProgressTowardsGoals.bind(this);
    this.onSaveAsDraft = this.onSaveAsDraft.bind(this);
    
  };

  componentWillMount() {
    this.props.getMasterData();
    // this.props.getPatientDetailsById(this.state.patient_id);
    if (this.state.apptid) {
      // this.props.getAppointmentById(this.state.apptid);
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    // let patientInsuranceId = this.props.get_soap && this.props.get_soap.data && this.props.get_soap.data.patientAppointment &&this.props.get_soap.data.patientAppointment.patientInsuranceId;
    // let appointmentTypeId = this.props.get_soap && this.props.get_soap.data && this.props.get_soap.data.patientAppointment &&this.props.get_soap.data.patientAppointment.appointmentTypeID;
    // this.props.getAppConfigList(patientInsuranceId, appointmentTypeId);

    this.props.app_config.forEach((obj)=>{ 
      if(obj.key === "SHOW_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE"){
        this.setState({showClockInClockOut:obj.value})
      }
      
      if(obj.key === "REQUIRED_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE") {
        this.setState({isClockInClockOutMandate:obj.value}) 
      }  
  })

  if (this.props.get_soap&&this.props.get_soap.data&&this.props.get_soap.data.notetypeId!==0) {
    this.setState({FormProps:this.props.get_soap.data})
    delay(()=>{ this.formatedSoapData(this.props.get_soap);},100)
   
  }
  }

    componentWillUnmount() {
      // Clear the narrative summary when unmounting
      this.props.clearNarrativeSummary();
      this.props.dispatch(change('soapForm', 'NarrativeSummary', ''));
      this.setState({
        narrativeAISummaryResponse: null
      });
    }

  componentDidUpdate(prevProps){
    if (this.props.get_soap !== prevProps.get_soap) {
      let patientInsuranceId = this.props.get_soap && this.props.get_soap.data && this.props.get_soap.data.patientAppointment &&this.props.get_soap.data.patientAppointment.patientInsuranceId;
      let appointmentTypeId = this.props.get_soap && this.props.get_soap.data && this.props.get_soap.data.patientAppointment &&this.props.get_soap.data.patientAppointment.appointmentTypeID;
      this.props.getAppConfigList(patientInsuranceId, appointmentTypeId);
    }
  }

  formPropDataPusher= ()=>{
    console.log(this.state.FormProps);
    
    if(this.state.FormProps!==null){
      return this.state.FormProps
    }
    return null
  }

  uploadDocumenthandler = () => {
    Alert.closeAll();
    this.setState({ openUploadDocument: true, uploadDocumentObj: null });
  }

  handleCloseHandler = () => {
    this.setState({ openUploadDocument: false });
  };

  handleCancel() {
    if(this.props.previousLocation!==null){
      history.push(this.props.previousLocation);
    }
    else{
      history.push('/scheduling');
    } 
  }

  handleAlertClick = (event) => {
    this.setState({clockInDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockIn(); });    
    Alert.closeAll();
  };

  noteDataGetter = (formdata)=>{
    this.setState({soapNoteDataFromModal:formdata})
    
  }

  handleClockIn = (event) => {
    let warningMsg = 'Are you sure you want to clock-in ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick       
      },
    });
  };

  handleClockOutAlertClick = (event) => {
    this.setState({clockOutDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockOut(); });    
    Alert.closeAll();
  };

  handleClockOut = (event) => {
    let warningMsg = 'Are you sure you want to clock-out ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleClockOutAlertClick       
      },
    });
  };

  handleMouseEnter = () => {
    if(!this.props.isFormValid){
      this.setState({isTooltipVisible : true})
    }
  }

  handleMouseLeave = () => {
    this.setState({isTooltipVisible : false})
  }

  formatedSoapData(soapDetail) {
    if (soapDetail) {
      let soapObj = soapDetail.data;
      // bind appointment data .....
      let appointmentData = soapObj.patientAppointment;
      let staffIds = [];
      let staffNames = [];
      let signatureStaffs = [];
      appointmentData.appointmentSingleStaff.forEach((staff) => {
        staffNames.push(staff.staffName);
        staffIds.push(staff.staffId);
        signatureStaffs.push({ 'id': staff.staffId, 'value': staff.staffName });
      });

      let renderingProviderIds = [];
      let renderingProviderNames = [];
      let signatureRenderingProviders = [];      

      appointmentData.appointmentRenderingProviders.forEach((staff) => {
        renderingProviderNames.push(staff.renderingProviderName);
        renderingProviderIds.push(staff.renderingProviderId);
        signatureRenderingProviders.push({ 'id': staff.renderingProviderId, 'value': staff.renderingProviderName });
      });

      let patientSessionNotesSkillsAcquisitionData = [];
        if (appointmentData.patientSessionNotesSkillsAcquisitionData && appointmentData.patientSessionNotesSkillsAcquisitionData.length) {          
          appointmentData.patientSessionNotesSkillsAcquisitionData.forEach((obj, index) => {
            patientSessionNotesSkillsAcquisitionData.push({
              'Id': obj.targetId,
              'programName': obj.programName,
              'targetName': obj.targetName,
              'targetData': obj.targetData,
            });
          });
          this.setState({
            patientSessionNotesSkillsAcquisitionDataArr: patientSessionNotesSkillsAcquisitionData,
          });                    
        }
        let patientBehaviorReductionData = [];
        if (appointmentData.patientBehaviorReductionData && appointmentData.patientBehaviorReductionData.length) {          
          appointmentData.patientBehaviorReductionData.forEach((obj, index) => {
            patientBehaviorReductionData.push({
              'Id': obj.behaviorsReductionId,
              'behaviorName': obj.behaviorName,
              'recordingTypeName': obj.recordingTypeName,
              'behaviorData': obj.behaviorData,
            });
          });
          this.setState({
            patientSessionNotesBehaviorReductionDataArr: patientBehaviorReductionData,
          });                    
        }

      let staffID = staffIds && staffIds.length ? staffIds[0] : null;
      let staffName = staffNames && staffNames ? staffNames.join(',') : '';
      let renderingProviderID = renderingProviderIds && renderingProviderIds.length ? renderingProviderIds[0] : null;
      let renderingProviderName = renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '';
      let appointmentTypeName = appointmentData.appointmentTypeName;
      let appointmentTypeIsBillable = appointmentData.isBillable;
      let appointmentDate = showFormatedDate(appointmentData.dateOfService);
      let appointmentTime = showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime);
      let patientName = appointmentData.patientName;
      // let appointmentTime = `${formattedStartTimehours}:${appointmentData.StartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${appointmentData.EndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      let PatientLocationID = '';
      let PatientLocationName = appointmentData.address;
      if (!appointmentTypeIsBillable) {
        this.setState({ isAllSigned: true });
      }
      // to get the patient info panel ..
      if (appointmentData.patientID) {
        this.props.getPatientProfileDetails(appointmentData.patientID);
      }

      this.setState({
        isEvvPayer: appointmentData.isEvvPayer ||  appointmentData.clockInAndClockOutEVV,
        appointment: appointmentData,
        ParentAppointmentID: appointmentData.parentAppointmentId,
        staffID: staffID,
        staffName: staffName,
        renderingProviderID: renderingProviderID,        
        renderingProviderName: renderingProviderName,
        patient_id: appointmentData.patientID,
        patientName: patientName,
        appointmentTypeName: appointmentTypeName,
        appointmentTypeIsBillable: appointmentTypeIsBillable,
        appointmentDate: appointmentDate,
        appointmentTime: appointmentTime,
        DateTimeOfVisit: `${appointmentDate}, ${appointmentTime}`,
        PatientLocationName: PatientLocationName,
        PatientLocationID: PatientLocationID,
        DateOfService: appointmentData.startDateTime,
        appointmentStartDateTime: appointmentData.startDateTime,
        appointmentEndDateTime: appointmentData.endDateTime,
        serviceStartTime: appointmentData.startDateTime,
        serviceEndTime: appointmentData.endDateTime,
        showCompleteButton: appointmentTypeIsBillable && this.state.encounterId && ((appointmentData.claimId > 0 || appointmentData.isSavedAsDraft === false) ? true : false),
        signatureStaffs: signatureStaffs,
        serviceFacility: appointmentData.serviceFacility,
        isDirectService: appointmentData.isDirectService,
        isAdminUpdateAfterRendered: (appointmentData.claimId && appointmentData.canEdit),
        isDataCollectionEnabledForAgency: appointmentData.isDataCollectionEnabledForAgency,
        timeDifference: appointmentData.timeDifference,
        clockInDateTime: appointmentData.clockInDateTime,
        clockOutDateTime: appointmentData.clockOutDateTime,
        claimRenderingProvider: appointmentData.claimRenderingProvider,
        isSavedAsDraft: appointmentData.isSavedAsDraft,
        isFormSubmitted: appointmentTypeIsBillable && this.state.encounterId && appointmentData.isSavedAsDraft === false ? true : false,
        isServiceTimeOver: appointmentData.isServiceTimeOver,
      }, () => {
        if (soapObj.id && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
          // this.setState({
          //   serviceStartTime: soapObj.startDateTime,
          //   serviceEndTime: soapObj.endDateTime,
          // });
        }
        let icdArray = [];
        if (soapObj.patientEncounterDiagnosisCodes && soapObj.patientEncounterDiagnosisCodes.length) {
          soapObj.patientEncounterDiagnosisCodes.forEach((obj, index) => {
            icdArray.push({
              'DiagnosisDate': moment(obj.diagnosisDate).format(),
              'Description': obj.description,
              'ICDCodeId': obj.icdCodeId,
              'ICDCode': obj.icdCode,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
            });
          });
          this.setState({
            diagnosisArray: icdArray,
          });
        }
        let cptArray = [];
        if (soapObj.patientEncounterServiceCodes && soapObj.patientEncounterServiceCodes.length) {
          soapObj.patientEncounterServiceCodes.forEach((obj, index) => {
            cptArray.push({
              'AuthProcedureCPTLinkId': obj.authProcedureCPTLinkId,
              'AuthorizationNumber': obj.authorizationNumber,
              'ServiceCodeId': obj.serviceCodeId,
              'ServiceCode': obj.serviceCode,
              'Description': obj.description,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
              'Modifier1': obj.modifier1,
              'Modifier2': obj.modifier2,
              'Modifier3': obj.modifier3,
              'Modifier4': obj.modifier4,
              'AttachedModifiers': obj.attachedModifiers,
            });
          });
        }
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isGuardianSigned = true;
              this.setState({ GuardianSign: data });
            }
            if (signObj.patientSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: this.state.patientName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isClientSigned = true;
              this.setState({ ClientSign: data });
            }
            if (signObj.clinicianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: this.state.staffName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isEmployeeSigned = true;
              this.setState({ EmployeeSign: data });
            }
            if (signObj.renderingProviderSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                //Name: this.state.renderingProviderName,
                Name: signObj.renderingProviderName ? signObj.renderingProviderName : this.state.renderingProviderName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              this.filter.isRenderingProviderSigned = true;
              this.setState({ RenderingProviderSign: data });
            }
          });
        }
        if ((soapObj.status || '').toLowerCase() === 'rendered' && appointmentData.claimId && !this.state.isSavedAsDraft) {
          if (this.state.isAdminUpdateAfterRendered !== undefined && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
            this.setState({ isSessionPending: false, isSoapCompleted: true, isAllSigned: true });
          } else {
            this.setState({ isAllSigned: true });
          }
        } else if ((soapObj.status || '').toLowerCase() === 'rendered' && !appointmentData.claimId && !this.state.isSavedAsDraft) {
          this.setState({ isSessionPending: true });
        } else if ((soapObj.status || '').toLowerCase() === 'pending' && !this.state.isSavedAsDraft) {
            this.setState({ isSessionPending: true });
        }
        if (!this.filter.isGuardianSigned) {
          let employee_signRequired = this.state.signRequired.employee_sign,
            client_signRequired = this.state.signRequired.client_sign,
            guardian_signRequired = this.state.signRequired.guardian_sign,
            rederingProvider_signRequired = this.state.signRequired.rederingProvider_sign;
          if (appointmentData && !appointmentData.isDirectService && this.state.signRequired.guardian_sign) {
            guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
          }

          this.setState({
            signRequired: {
              employee_sign: employee_signRequired,
              client_sign: client_signRequired,
              guardian_sign: guardian_signRequired,
              rederingProvider_sign: rederingProvider_signRequired,
            },
          }, () => {
            this.setState({
              isAllSigned: this.checkIsAllRequiredSigned(),
            });
          });
        }
        this.setState({
          isAllSigned: this.checkIsAllRequiredSigned(),
          get_soap: soapDetail.data,
          CPTTableData: cptArray,
          diagnosisArray: icdArray,
        },()=>{
          if(this.state.isGenerateClaimAfterRendered)
          {     
            var link = document.getElementById('btnComplete');      
            if(link)      
              link.click();            
          }
        });
      });
    }
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.match.params.encId !== this.props.match.params.encId) {
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
        master_CPT: nextProps.master_data.masterCPT,
      });
    }
    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let employee_signRequired = false;
      let client_signRequired = false;
      let guardian_signRequired = false;
      let rederingProvider_signRequired = false;
      let restrictSignaturesBeforeAppointmentEndTime = false;
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 1) {
            switch (Obj.key) {
              case 'CLINICIAN_SIGN':
                employee_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'PATIENT_SIGN':
                client_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'GUARDIAN_SIGN':
                guardian_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'RENDERINGPROVIDER_SIGN':
                rederingProvider_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              default:
                break;
            }
          }
          else if (Obj.configType === 4) {
            switch (Obj.key) {            
            case 'RESTRICTSIGNATURE_BEFORE_APPOINTMENT_ENDDATE':
              restrictSignaturesBeforeAppointmentEndTime = (Obj.value.toString().toLowerCase() === 'true');
              break;
            default:
              break;
            }
          }
        });
      }

      this.setState({RestrictSignaturesBeforeAppointmentEndTime : restrictSignaturesBeforeAppointmentEndTime });
      if (!this.filter.isGuardianSigned) {
        // let isAnySignRequired = employee_signRequired || client_signRequired || guardian_signRequired;
        let patientAppointmentData = this.state.get_soap && this.state.get_soap.patientAppointment;
        // let isAppointmentRendered = this.state.get_soap && (this.state.get_soap.status || '').toLowerCase() === 'rendered';
        if (patientAppointmentData && !patientAppointmentData.isDirectService && guardian_signRequired) {
          guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
        }
        this.setState({
          // isAllSigned: !isAnySignRequired,
          signRequired: {
            employee_sign: employee_signRequired,
            client_sign: client_signRequired,
            guardian_sign: guardian_signRequired,
            rederingProvider_sign: rederingProvider_signRequired,
          },
        }, () => {
          this.setState({
            isAllSigned: this.checkIsAllRequiredSigned(),
          });
        });
      }
    }

    if (nextProps.saved_soap && this.props.saved_soap !== nextProps.saved_soap) {
      if (nextProps.saved_soap.id) {
        if (!this.state.encounterId) {
          history.push(`/session-notes-bt-default/${this.state.apptid}/${nextProps.saved_soap.id}/${this.state.isAdminUpdateAfterRendered ? 1 : 0}/0`);
        } else {
          this.setState({ isSavedAsDraft: nextProps.saved_soap.isSavedAsDraft },() =>{
            if(nextProps.saved_soap.isSavedAsDraft)            
              this.setState({ isSoapCompleted: false});
             else {
              if (this.state.isAdminUpdateAfterRendered !== undefined && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
                this.setState({ isSessionPending: false });
              } else {
                this.setState({ isSessionPending: true});
              }
             }
          });
        }

        //this.setState({ encounterId: nextProps.saved_soap.id, showCompleteButton: this.state.appointmentTypeIsBillable ? true : false });
        this.setState({ encounterId: nextProps.saved_soap.id, showCompleteButton: (this.state.claimId > 0 || nextProps.saved_soap.isSavedAsDraft === false) && this.state.appointmentTypeIsBillable ? true : false, isFormSubmitted: nextProps.saved_soap.isSavedAsDraft === false && this.state.appointmentTypeIsBillable ? true : false });
        if (this.state.pendingNarrativeGeneration) {
          this.setState({ 
            pendingNarrativeGeneration: false,
            isGeneratingNarrativeSummary: true 
          }, () => {
              this.setState({ isGeneratingNarrativeSummary: true });
              this.props.generateNarrativeSummary(this.state.encounterId);
          });
        }
      }
    }
    
   if(this.props.match.params.encId > 0 && nextProps.TypeOfObservation !== this.props.TypeOfObservation){
   //   if(this.props.match.params.encId > 0){
      this.setState({TypeOfObservation: nextProps.TypeOfObservation || 0 },()=>{this.changeIsTypeOfObservation(null,nextProps.TypeOfObservation || 0)});      
   }

   if(this.props.match.params.encId > 0 && nextProps.ProgressTowardsGoals !== this.props.ProgressTowardsGoals){
    //if(this.props.match.params.encId > 0){
     this.setState({ProgressTowardsGoals: nextProps.ProgressTowardsGoals || 0 },()=>{this.changeIsProgressTowardsGoals(null,nextProps.ProgressTowardsGoals || 0)});      
   }     

    if (nextProps.get_soap && this.props.get_soap !== nextProps.get_soap) {
      this.formatedSoapData(nextProps.get_soap);
    }

    if (nextProps.saved_EncounterSigns && nextProps.saved_EncounterSigns !== this.props.saved_EncounterSigns) {
      let signObj = nextProps.saved_EncounterSigns.data;
      if (signObj.guardianSign) {
        let data = this.state.GuardianSign;
        data.id = signObj.id;
        this.setState({ GuardianSign: data });
      }
      if (signObj.patientSign) {
        let data = this.state.ClientSign;
        data.id = signObj.id;
        this.setState({ ClientSign: data });
      }
      if (signObj.clinicianSign) {
        let data = this.state.EmployeeSign;
        data.id = signObj.id;
        this.setState({ EmployeeSign: data });
      }
      if (signObj.renderingProviderSign) {
        let data = this.state.RenderingProviderSign;
        data.id = signObj.id;
        this.setState({ RenderingProviderSign: data });
      }
    }


    if (nextProps.clockInLatitude && nextProps.clockInLatitude > 0 && this.props.clockInLatitude !== nextProps.clockInLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockInDateTime': this.state.clockInDateTime,
        'clockInLatitude' : nextProps.clockInLatitude || 0.0,
        'clockInLongitude' : nextProps.clockInLongitude || 0.0,
      }
      this.props.saveClockInTimeIntoAppointment(formData);
    }

    if (nextProps.clockOutLatitude && nextProps.clockOutLatitude > 0 && this.props.clockOutLatitude !== nextProps.clockOutLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockOutDateTime': this.state.clockOutDateTime,
        'clockOutLatitude' : nextProps.clockOutLatitude || 0.0,
        'clockOutLongitude' : nextProps.clockOutLongitude || 0.0,
      }     
      this.props.saveClockOutTimeIntoAppointment(formData);
    }

    if(nextProps.isGeneratingNarrativeSummary != null && this.state.isGeneratingNarrativeSummary != nextProps.isGeneratingNarrativeSummary)
      this.setState({ isGeneratingNarrativeSummary: nextProps.isGeneratingNarrativeSummary });
    
    if (nextProps.narrativeAISummaryResponse && this.state.narrativeAISummaryResponse !== nextProps.narrativeAISummaryResponse) {
      this.setState({ 
        narrativeAISummaryResponse: nextProps.narrativeAISummaryResponse,
      }, ()=>{
          this.props.dispatch(change('soapForm', 'NarrativeSummary', nextProps.narrativeAISummaryResponse));
      });      
    }

  };
  
  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  onSaveAsDraft(formProps) {
    this.setState({isSavedAsDraft : true},() => {
      this.submitFormData(formProps);
    });       
  }

  onCompleteSoap(formProps) {
    if(!this.state.isEvvPayer){
      if (this.state.isClockInClockOutMandate==="true" && (this.state.clockInDateTime===undefined || this.state.clockOutDateTime===undefined)){
        Alert.warning('Please record clock-in and clock-out time before rendering the session', {
          position: 'bottom-right',
          effect: 'slide',
        });
        return false;
      }
    }
   
    this.setState({ isSavedAsDraft : false, IsHideOnlyCompleteButton: true, isGenerateClaimAfterRendered: false, isFormSubmitted: true },() => {
      let isGenerateClaim = true;
      this.submitFormData(formProps, isGenerateClaim);
    });    
  }

  onSubmit(formProps) {
    if(this.state.isEvvPayer){
      this.setState({FormProps:formProps})
    }
    //this.submitFormData(formProps);
    this.setState({isFormSubmitted: true},() => {
      // if(this.state.appointmentTypeIsBillable === false || (formProps.PeoplePresentParticipate != undefined && formProps.PeoplePresentParticipate.trim() !== '' && formProps.SettingEventReported != undefined && formProps.SettingEventReported.trim() !== '' && formProps.AtypicalBehaviorsReported != undefined && formProps.AtypicalBehaviorsReported.trim() !== '' && formProps.ClientResponseToSignificantOthers != undefined && formProps.ClientResponseToSignificantOthers.trim() !== ''
      // && formProps.NarrativeSummary != undefined && formProps.NarrativeSummary.trim() !== ''))
      if(formProps.PeoplePresentParticipate != undefined && formProps.PeoplePresentParticipate.trim() !== '' && formProps.SettingEventReported != undefined && formProps.SettingEventReported.trim() !== '' && formProps.AtypicalBehaviorsReported != undefined && formProps.AtypicalBehaviorsReported.trim() !== '' && formProps.ClientResponseToSignificantOthers != undefined && formProps.ClientResponseToSignificantOthers.trim() !== ''
      && formProps.NarrativeSummary != undefined && formProps.NarrativeSummary.trim() !== '')     
      {
        this.setState({isSavedAsDraft : false},() => {
          this.submitFormData(formProps);
        });
      }
    });
  };

  handleGenerateAISummary = (formProps) => {
    Alert.closeAll();
    this.setState({
      isSavedAsDraft: true,
      pendingNarrativeGeneration: true
    },() => {
      this.submitFormData(formProps);
    });    
  }

  submitFormData(formProps, isGenerateClaim = false) {

    
    if (!this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length) {
      Alert.warning('Please add atleast one diagnosis!', {
        position: 'bottom-right',
        effect: 'slide',
      });
      return false;
    }
    if (this.state.appointmentTypeIsBillable) {
      if (!this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length) {
        Alert.warning('Please add atleast one service code!', {
          position: 'bottom-right',
          effect: 'slide',
        });
        return false;
      }
    }

    let ICDArray = this.state.diagnosisArray;
    let CPTcodes = this.state.CPTTableData;
    let formData = {
      'Id': this.state.encounterId,
      'PatientID': this.state.patient_id,
      'AppointmentStartDateTime': this.state.appointmentStartDateTime,
      'AppointmentEndDateTime': this.state.appointmentEndDateTime,
      'PatientAppointmentId': this.state.encounterId || !this.state.appointment.RecurrenceRule ? this.state.apptid : null,
      'ParentAppointmentId': this.state.encounterId ? null : this.state.ParentAppointmentID,
      'DateOfService': this.state.DateOfService,
      'StartDateTime': moment(this.state.serviceStartTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceStartTime).format('HH:mm:ss'),
      'EndDateTime': moment(this.state.serviceEndTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceEndTime).format('HH:mm:ss'),
      'StaffID': this.state.staffID,
      // 'LocationID': this.props.singleEncounter.locationID,
      'ServiceLocationID': this.state.appointment ? this.state.appointment.serviceLocationID : null,
      'OfficeAddressID': this.state.appointment ? this.state.appointment.officeAddressID : null,
      'PatientAddressID': this.state.appointment ? this.state.appointment.patientAddressID : null,
      'CustomAddressID': this.state.appointment ? this.state.appointment.customAddressID : null,
      'CustomAddress': this.state.appointment ? this.state.appointment.customAddress : null,
      'ServiceAddress': this.state.appointment ? this.state.appointment.address : null,
      // 'PatientSign': this.state.ClientSign.Bytes,
      // 'PatientSignDate': this.state.ClientSign.Date,
      // 'ClinicianSign': this.state.EmployeeSign.Bytes,
      // 'ClinicianSignDate': this.state.EmployeeSign.Date,
      // 'GuardianSign': this.state.GuardianSign.Bytes,
      // 'GuardianSignDate': this.state.GuardianSign.Date,
      // 'GuardianName': this.state.GuardianSign.Name,
      'NotetypeId': 101,
      'SessionNotes_BT_Default': {
        'Id': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default ? this.state.get_soap.sessionNotes_BT_Default.id : 0,
        'PeoplePresentParticipate': formProps.PeoplePresentParticipate ||this.state.soapNoteDataFromModal && this.state.soapNoteDataFromModal.peoplePresentParticipate,
        'SettingEventReported': formProps.SettingEventReported || this.state.soapNoteDataFromModal && this.state.soapNoteDataFromModal.settingEventReported,
        'AtypicalBehaviorsReported': formProps.AtypicalBehaviorsReported || this.state.soapNoteDataFromModal && this.state.soapNoteDataFromModal.atypicalBehaviorsReported,
        'ClientResponseToSignificantOthers': formProps.ClientResponseToSignificantOthers || this.state.soapNoteDataFromModal && this.state.soapNoteDataFromModal.clientResponseToSignificantOthers,
        'BT_Default_Subjective': [{
          'BTDefaultSubjectiveId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default && this.state.get_soap.sessionNotes_BT_Default.bT_Default_Subjective ? this.state.get_soap.sessionNotes_BT_Default.bT_Default_Subjective[0].id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default ? this.state.get_soap.sessionNotes_BT_Default.id : 0,
          'BehaviorTechnician': formProps.BehaviorTechnician || 0,
          'Parent': formProps.Parent || 0,
          'MidLevelSupervisor': formProps.MidLevelSupervisor || 0,
          'BCBA': formProps.BCBA || 0,
          'Other': formProps.Other || 0,
          'OtherNotes': formProps.Other ? formProps.OtherNotes : '',
          'TypeOfObservation': formProps.TypeOfObservation || 0,
        }],
        'BT_Default_Objective': [{
          'BTDefaultObjectiveId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default && this.state.get_soap.sessionNotes_BT_Default.BT_Default_Objective ? this.state.get_soap.sessionNotes_BT_Default.BT_Default_Objective.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default ? this.state.get_soap.sessionNotes_BT_Default.id : 0,
          'BuildRapport': formProps.BuildRapport || 0,
          'SkillAcquisitionGoals': formProps.SkillAcquisitionGoals || 0,
          'GeneralizationOfSkillsOrBehaviors': formProps.GeneralizationOfSkillsOrBehaviors || 0,
          'MaintenanceGoals': formProps.MaintenanceGoals || 0,
          'DecreasingMaladaptiveBehaviors': formProps.DecreasingMaladaptiveBehaviors || 0,
          'OtherGoalsForSession': formProps.OtherGoalsForSession || 0,
          'OtherGoalsForSessionNotes': formProps.OtherGoalsForSessionNotes ? formProps.OtherGoalsForSessionNotes : '',

          'Behavior': formProps.Behavior || 0,
          'Communication': formProps.Communication || 0,
          'ExecutiveFunctioning': formProps.ExecutiveFunctioning || 0,
          'SocialSkills': formProps.SocialSkills || 0,
          'AdaptiveSkills': formProps.AdaptiveSkills || 0,
          'CommunityOrSafetySkills': formProps.CommunityOrSafetySkills || 0,
          'OtherDomainsAddressed': formProps.OtherDomainsAddressed || 0,
          'OtherDomainsAddressedNotes': formProps.OtherDomainsAddressedNotes ? formProps.OtherDomainsAddressedNotes :  '',

          'AntecedentBasedIntervention': formProps.AntecedentBasedIntervention || 0,
          'DifferentialReinforcement': formProps.DifferentialReinforcement || 0,
          'DiscreteTrialTeaching': formProps.DiscreteTrialTeaching || 0,
          'Extinction': formProps.Extinction || 0,
          'FunctionalCommunicationTraining': formProps.FunctionalCommunicationTraining || 0,
          'Modeling': formProps.Modeling || 0,

          'IncidentalTeaching': formProps.IncidentalTeaching || 0,
          'PivotalResponseTraining': formProps.PivotalResponseTraining || 0,
          'Prompting': formProps.Prompting || 0,
          'Reinforcement': formProps.Reinforcement || 0,
          'ResponseInterruptionAndRedirection': formProps.ResponseInterruptionAndRedirection || 0,
          'SocialSkillsTraining': formProps.SocialSkillsTraining || 0,
          'TaskAnalysis': formProps.TaskAnalysis || 0,
          'TimeDelay': formProps.TimeDelay || 0,
          'Shaping': formProps.Shaping || 0,
          'VisualSupports': formProps.VisualSupports || 0,
          'OtherEvidenceBasedPractices': formProps.OtherEvidenceBasedPractices || 0,
          'OtherEvidenceBasedPracticesNotes': formProps.OtherEvidenceBasedPracticesNotes ? formProps.OtherEvidenceBasedPracticesNotes : '',
        }],
        'BT_Default_Assessment': [{
          'BTDefaultAssessmentId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default && this.state.get_soap.sessionNotes_BT_Default.BT_Default_Assessment ? this.state.get_soap.sessionNotes_BT_Default.BT_Default_Assessment.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default ? this.state.get_soap.sessionNotes_BT_Default.id : 0,
          'Motorstereotypies': formProps.Motorstereotypies || 0,
          'Stereotypieswithobjects': formProps.Stereotypieswithobjects || 0,
          'EcholaliaAndIdiosyncraticSpeech': formProps.EcholaliaAndIdiosyncraticSpeech || 0,
          'ExtremeDistressAtSmallChange': formProps.ExtremeDistressAtSmallChange || 0,
          'DifficultiesWithTransition': formProps.DifficultiesWithTransition || 0,
          'RigidGreetingRituals': formProps.RigidGreetingRituals || 0,
          'StrongAttachmentsToPreoccupation': formProps.StrongAttachmentsToPreoccupation || 0,
          'ExcessivelyCircumscribedOrPerseverativeInterests': formProps.ExcessivelyCircumscribedOrPerseverativeInterests || 0,
          'ApparentIndifferenceToPainOrTemperature': formProps.ApparentIndifferenceToPainOrTemperature || 0,
          'AdverseResponseToSpecificSights': formProps.AdverseResponseToSpecificSights || 0,
          'VisualFascinationWithLightsOrMovement': formProps.VisualFascinationWithLightsOrMovement || 0,
          'OtherRestrictedPatternsOfBehavior': formProps.OtherRestrictedPatternsOfBehavior || 0,
          'OtherRestrictedPatternsOfBehaviorNotes': formProps.OtherRestrictedPatternsOfBehaviorNotes ? formProps.OtherRestrictedPatternsOfBehaviorNotes : '',

          'SharingOfInterests': formProps.SharingOfInterests || 0,
          'RespondingToSocialInteractions': formProps.RespondingToSocialInteractions || 0,
          'InitiatingSocialInteractions': formProps.InitiatingSocialInteractions || 0,
          'BackAndForthConversations': formProps.BackAndForthConversations || 0,
          'SocialApproach': formProps.SocialApproach || 0,
          'NonverbalCommunication': formProps.NonverbalCommunication || 0,
          'IntegratingNonverbalAndVerbalCommunication': formProps.IntegratingNonverbalAndVerbalCommunication || 0,
          'EyeContactAndBodyLanguage': formProps.EyeContactAndBodyLanguage || 0,
          'FacialExpression': formProps.FacialExpression || 0,
          'UnderstandingAndUseOfGestures': formProps.UnderstandingAndUseOfGestures || 0,
          'SharingImaginativePlay': formProps.SharingImaginativePlay || 0,
          'MakingFriends': formProps.MakingFriends || 0,
          'IncreasingInterestInPeer': formProps.IncreasingInterestInPeer || 0,
          'OtherSocialCommunication': formProps.OtherSocialCommunication || 0,
          'OtherSocialCommunicationNotes': formProps.OtherSocialCommunicationNotes ? formProps.OtherSocialCommunicationNotes : '',

          'NarrativeSummary': formProps.NarrativeSummary !== null? formProps.NarrativeSummary : this.state.soapNoteDataFromModal.narrativeSummary,

          'Inattentiveness': formProps.Inattentiveness || 0,
          'Hyperactivity': formProps.Hyperactivity || 0,
          'HighRateOfMaladaptiveBehaviors': formProps.HighRateOfMaladaptiveBehaviors || 0,
          'ScrollingResponses': formProps.ScrollingResponses || 0,
          'RatioStrain': formProps.RatioStrain || 0,
          'ReinforcerDependent': formProps.ReinforcerDependent || 0,
          'PromptDependence': formProps.PromptDependence || 0,
          'HighRateOfSelfStimulatoryBehavior': formProps.HighRateOfSelfStimulatoryBehavior || 0,
          'MotivationWeakenedByResponseRequirement': formProps.MotivationWeakenedByResponseRequirement || 0,
          'SensoryDefensiveness': formProps.SensoryDefensiveness || 0,
          'ObsessiveCompulsiveBehavior': formProps.ObsessiveCompulsiveBehavior || 0,
          'OtherBarriersToTreatment': formProps.OtherBarriersToTreatment || 0,          
          'OtherBarriersToTreatmentNotes': formProps.OtherBarriersToTreatmentNotes ? formProps.OtherBarriersToTreatmentNotes : '',

          'ProgressTowardsGoals': formProps.ProgressTowardsGoals || 0,

        }],
        'BT_Default_Plan': [{
          'BTDefaultPlanId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default && this.state.get_soap.sessionNotes_BT_Default.BT_Default_Plan ? this.state.get_soap.sessionNotes_BT_Default.BT_Default_Plan.id : 0,
          'SessionNoteId': this.state.get_soap && this.state.get_soap.sessionNotes_BT_Default ? this.state.get_soap.sessionNotes_BT_Default.id : 0,
          'ContinueWithProgramming': formProps.ContinueWithProgramming || 0,          
          'DiscussProgramProgress': formProps.DiscussProgramProgress || 0,                    
          'OtherNextSteps': formProps.OtherNextSteps || 0,
          'OtherNextStepsNotes': formProps.OtherNextStepsNotes ? formProps.OtherNextStepsNotes : '',
        }],
        
      },
      'PatientEncounterServiceCodes': CPTcodes,
      'PatientEncounterDiagnosisCodes': ICDArray,
      'isBillableEncounter': this.state.appointmentTypeIsBillable ? true : false,
      'isSavedAsDraft': this.state.isSavedAsDraft ? true : false,
      'ReasonForRenderingFromWeb':this.state.reasonCodeState
    };
    // console.log('submit data =========',formData);
    let whoWasPresentInSessionPermission = false;
    let GoalsForSessionPermission = false;
    let DomainsAddressedPermission = false;    
    let EvidenceBasedPracticesPermission = false;    
    let restrictedPatternsOfBehaviorPermission = false;    
    let socialCommunicationInteractionPermission = false;    
    let barriersToTreatmentPermission = false;    
    let whatAreTheNextStepsPermission = false;    

    // Check directly formData
    if(formData.SessionNotes_BT_Default.BT_Default_Subjective) {
        let whoWasPresentInSession = formData.SessionNotes_BT_Default.BT_Default_Subjective && formData.SessionNotes_BT_Default.BT_Default_Subjective[0];
        let objective = formData.SessionNotes_BT_Default.BT_Default_Objective && formData.SessionNotes_BT_Default.BT_Default_Objective[0];        
        let assessment = formData.SessionNotes_BT_Default.BT_Default_Assessment && formData.SessionNotes_BT_Default.BT_Default_Assessment[0];
        let plan = formData.SessionNotes_BT_Default.BT_Default_Plan && formData.SessionNotes_BT_Default.BT_Default_Plan[0];

        // For Who was present in session
        if(this.state.isFormSubmitted && (whoWasPresentInSession.BehaviorTechnician === 0 && whoWasPresentInSession.Parent === 0 && whoWasPresentInSession.MidLevelSupervisor === 0 && whoWasPresentInSession.BCBA === 0 && whoWasPresentInSession.Other === 0)) {
          whoWasPresentInSessionPermission = false;
          this.setState({ isWhoWasPresentInSessionAllowed: false });
        } else {
          whoWasPresentInSessionPermission = true;
          this.setState({ isWhoWasPresentInSessionAllowed: true });
        }

        // For Goals for Session 
        if(this.state.isFormSubmitted && (objective.BuildRapport === 0 && objective.SkillAcquisitionGoals === 0 && objective.GeneralizationOfSkillsOrBehaviors === 0 && objective.MaintenanceGoals === 0 && objective.DecreasingMaladaptiveBehaviors === 0 )) { //&& objective.OtherGoalsForSession === 0
          GoalsForSessionPermission = false;
          this.setState({ isGoalsForSessionAllowed : false })
        } else {
          GoalsForSessionPermission = true;
          this.setState({ isGoalsForSessionAllowed: true })
        }

        // For Domains Addressed 
        if(this.state.isFormSubmitted && (objective.Behavior === 0 && objective.Communication === 0 && objective.ExecutiveFunctioning === 0 && objective.SocialSkills === 0 && objective.AdaptiveSkills === 0 && objective.CommunityOrSafetySkills === 0)) { // && objective.OtherDomainsAddressed === 0
          DomainsAddressedPermission = false;
          this.setState({ isDomainsAddressedAllowed : false })
        } else {
          DomainsAddressedPermission = true;
          this.setState({ isDomainsAddressedAllowed: true })
        }

        // For Domains Addressed 
        if(this.state.isFormSubmitted && (objective.AntecedentBasedIntervention === 0 && objective.DifferentialReinforcement === 0 && objective.DiscreteTrialTeaching === 0 && objective.Extinction === 0 && objective.FunctionalCommunicationTraining === 0 && objective.Modeling === 0 && objective.IncidentalTeaching === 0
          && objective.PivotalResponseTraining === 0 && objective.Prompting === 0 && objective.Reinforcement === 0 && objective.ResponseInterruptionAndRedirection === 0 && objective.SocialSkillsTraining === 0
          && objective.TaskAnalysis === 0 && objective.TimeDelay === 0 && objective.Shaping === 0 && objective.VisualSupports === 0 && objective.OtherEvidenceBasedPractices === 0)) {
          EvidenceBasedPracticesPermission = false;
          this.setState({ isEvidenceBasedPracticesAllowed : false })
        } else {
          EvidenceBasedPracticesPermission = true;
          this.setState({ isEvidenceBasedPracticesAllowed: true })
        }

        // DSM-5 Deficits to Remediate: Restricted Patterns of Behavior 
        if(this.state.isFormSubmitted && (assessment.Motorstereotypies === 0 && assessment.Stereotypieswithobjects === 0 && assessment.EcholaliaAndIdiosyncraticSpeech === 0 && assessment.ExtremeDistressAtSmallChange === 0 && assessment.DifficultiesWithTransition === 0 && assessment.RigidGreetingRituals === 0 && assessment.StrongAttachmentsToPreoccupation === 0 && assessment.ExcessivelyCircumscribedOrPerseverativeInterests === 0 && assessment.ApparentIndifferenceToPainOrTemperature === 0
          && assessment.AdverseResponseToSpecificSights === 0 && assessment.VisualFascinationWithLightsOrMovement === 0 && assessment.OtherRestrictedPatternsOfBehavior === 0)) {
          restrictedPatternsOfBehaviorPermission = false;
          this.setState({ isRestrictedPatternsOfBehaviorAllowed : false })
        } else {
          restrictedPatternsOfBehaviorPermission = true;
          this.setState({ isRestrictedPatternsOfBehaviorAllowed : true })
        }

        //DSM-5 Deficits to Remediate: Social Communication / Interaction 
        if(this.state.isFormSubmitted && (assessment.SharingOfInterests === 0 && assessment.RespondingToSocialInteractions === 0 && assessment.InitiatingSocialInteractions === 0 && assessment.BackAndForthConversations === 0 && assessment.SocialApproach === 0 && assessment.NonverbalCommunication === 0 && assessment.IntegratingNonverbalAndVerbalCommunication === 0 && assessment.EyeContactAndBodyLanguage === 0 && assessment.FacialExpression === 0
          && assessment.UnderstandingAndUseOfGestures === 0 && assessment.SharingImaginativePlay === 0 && assessment.MakingFriends === 0 && assessment.IncreasingInterestInPeer === 0 && assessment.OtherSocialCommunication === 0)) {
          socialCommunicationInteractionPermission = false;
          this.setState({ isSocialCommunicationInteractionAllowed : false })
        } else {
          socialCommunicationInteractionPermission = true;
          this.setState({ isSocialCommunicationInteractionAllowed : true })
        }

        //Barriers to Treatment
        if(this.state.isFormSubmitted && (assessment.Inattentiveness === 0 && assessment.Hyperactivity === 0 && assessment.HighRateOfMaladaptiveBehaviors === 0 && assessment.ScrollingResponses === 0 && assessment.RatioStrain === 0 && assessment.ReinforcerDependent === 0 && assessment.PromptDependence === 0 && assessment.HighRateOfSelfStimulatoryBehavior === 0 && assessment.MotivationWeakenedByResponseRequirement === 0
          && assessment.SensoryDefensiveness === 0 && assessment.ObsessiveCompulsiveBehavior === 0 && assessment.OtherBarriersToTreatment === 0)) {
            barriersToTreatmentPermission = false;
            this.setState({ isBarriersToTreatmentAllowed : false })
        } else {
            barriersToTreatmentPermission = true;
            this.setState({ isBarriersToTreatmentAllowed : true })
        }


        //Plan 
        if(this.state.isFormSubmitted && (plan.ContinueWithProgramming === 0 && plan.DiscussProgramProgress === 0 && plan.OtherNextSteps === 0)) {
            whatAreTheNextStepsPermission = false;
            this.setState({ isWhatAreTheNextStepsAllowed : false })
        } else {
            whatAreTheNextStepsPermission = true;
            this.setState({ isWhatAreTheNextStepsAllowed : true })
        }
        
    }
  
    // check for user is Admin and Soap has been rendered ...
    let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission;   

    if(this.state.isFormSubmitted && formData.SessionNotes_BT_Default.PeoplePresentParticipate != '' && formData.SessionNotes_BT_Default.SettingEventReported != '' 
      && formData.SessionNotes_BT_Default.AtypicalBehaviorsReported != '' && formData.SessionNotes_BT_Default.ClientResponseToSignificantOthers != ''
      && formData.SessionNotes_BT_Default.BT_Default_Subjective[0].TypeOfObservation != 0 && formData.SessionNotes_BT_Default.BT_Default_Assessment[0].ProgressTowardsGoals != 0) {   
      if(whoWasPresentInSessionPermission === true && GoalsForSessionPermission === true && DomainsAddressedPermission === true && EvidenceBasedPracticesPermission === true && restrictedPatternsOfBehaviorPermission === true 
        && socialCommunicationInteractionPermission === true && barriersToTreatmentPermission === true && whatAreTheNextStepsPermission === true) {
        this.props.savePatientSoapExtensionAction(formData, isGenerateClaim, isAdminUpdateAfterRendered);
      } else {
        Alert.error('Please complete all required fields before saving your session note.', {
          position: 'bottom-right',
          effect: 'slide',
        });
      }
    }
    else if(!this.state.isFormSubmitted) {
      if(whoWasPresentInSessionPermission === true && GoalsForSessionPermission === true && DomainsAddressedPermission === true && EvidenceBasedPracticesPermission === true && restrictedPatternsOfBehaviorPermission === true 
        && socialCommunicationInteractionPermission === true && barriersToTreatmentPermission === true && whatAreTheNextStepsPermission === true) {
        this.props.savePatientSoapExtensionAction(formData, isGenerateClaim, isAdminUpdateAfterRendered);
      } else {
        Alert.error('Please complete all required fields before saving your session note.', {
          position: 'bottom-right',
          effect: 'slide',
        });
      }
    }
    
  }

  changeIsTypeOfObservation = (e, value) => {    
    this.setState({ TypeOfObservation: parseInt(value || 0, 10)});
  };

  changeIsProgressTowardsGoals = (e, value) => {    
    this.setState({ ProgressTowardsGoals: parseInt(value || 0, 10)});
  };

  handleOpen = () => {
    this.setState({ open: true, soapPage: true });
  };
  handleClose = () => {
    this.setState({ open: false ,openRenderModal:false});
  };
  handleOpenCPT = () => {
    this.setState({ openCPT: true, soapPage: true });
  };
  handleCloseCPT = () => {
    this.setState({ openCPT: false });
  };
  handleOpenSign = () => {
    if(this.state.RestrictSignaturesBeforeAppointmentEndTime)// && !this.state.isServiceTimeOver)
    {
      // console.log('moment(this.state.appointmentEndDateTime)YYYY-MM-DDTHH:mm:ss.......',(moment(this.state.appointmentEndDateTime).format('YYYY-MM-DD') + 'T' + moment(this.state.appointmentEndDateTime).format('HH:mm:ss')))
      // console.log(' moment(new Date()YYYY-MM-DD HH:mm:ss).......',(moment(new Date()).format('YYYY-MM-DD') + 'T' + moment(new Date()).format('HH:mm:ss')))
      if(this.checkIsBefore((moment(new Date()).format('YYYY-MM-DD') + 'T' + moment(new Date()).format('HH:mm:ss')), (moment(this.state.appointmentEndDateTime).format('YYYY-MM-DD') + 'T' + moment(this.state.appointmentEndDateTime).format('HH:mm:ss'))))
      {
        showErrorMessage('Signatures are restricted until the end time of appointment. Please obtain signatures on or after the appointment end time.');
      }
      else {
        this.props.getGeoLocation();    
        this.setState({ openSign: true, soapPage: true });
      } 
    } else {
      this.props.getGeoLocation();    
      this.setState({ openSign: true, soapPage: true });
    }
  };
  checkIsBefore = (date1, date2) => {
    return moment(date1).isBefore(date2);  
  }

  handleOpenConfirmationPopUpModal =() => {
    this.setState({openRenderModal : true})
  }

  reasonCodeGetter = (reasonCode)=>{
    console.log(reasonCode);
    console.log(this.props);
    this.setState({reasonCodeState:reasonCode})
}

  handleCloseSign = () => {
    this.setState({ openSign: false });
  };
  DiagnosisAlertClick = (e, index) => {
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ diagnosisArray: arr });
    }
  }
  handleRemoveDiagnosisClick = (e, index) => {
    Alert.warning('Are you sure you want to remove this diagnosis?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.DiagnosisAlertClick,
        id: index,
      },
    });
  }
  CPTCodeAlertClick = (e, data) => {
    if (data.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: data.AuthProcedureCPTLinkId,
      //   actionName: 'Delete',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let index = data.index;
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ CPTTableData: arr });
    }
  }
  handleRemoveCPTCodeClick = (e, data) => {
    Alert.warning('Are you sure you want to remove this service code?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.CPTCodeAlertClick,
        id: data,
      },
    });
  }
  renderDiagnosis() {
    if (this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).map((diagnosis, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="30%">{diagnosis.ICDCode}</TableRowColumn>
          <TableRowColumn width="70%">{diagnosis.Description ? diagnosis.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <TableRowColumn><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></TableRowColumn>
            : null} */}
        </TableRow>
      );
    });
  }
  renderCpt() {
    if (this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).map((cpt, index) => {
      // let data = {
      //   index: index,
      //   AuthProcedureCPTLinkId: cpt.AuthProcedureCPTLinkId,
      // };
      return (
        <TableRow key={index}>
          <TableRowColumn>{cpt.ServiceCode ? cpt.ServiceCode : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.AttachedModifiers ? cpt.AttachedModifiers : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.Description ? cpt.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <td width="10%"><button onClick={(e) => this.handleRemoveCPTCodeClick(e, data)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></td>
            : null} */}
        </TableRow>
      );
    });
  }

  renderSessionNotesSkillsAcquisition() {
    console
    if (this.state.patientSessionNotesSkillsAcquisitionDataArr.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.patientSessionNotesSkillsAcquisitionDataArr.map((obj, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="40%">{obj.programName}</TableRowColumn>
          <TableRowColumn width="40%">{obj.targetName}</TableRowColumn>
          <TableRowColumn width="20%">{obj.targetData.toFixed(2).toString() + ' %'}</TableRowColumn>          
        </TableRow>
      );
    });
  }

  renderSessionNotesBehaviorReduction() {
    if (this.state.patientSessionNotesBehaviorReductionDataArr.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.patientSessionNotesBehaviorReductionDataArr.map((obj, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="40%">{obj.behaviorName}</TableRowColumn>
          <TableRowColumn width="40%">{obj.recordingTypeName}</TableRowColumn>
          {obj.recordingTypeName.toLowerCase() === 'partial interval' || obj.recordingTypeName.toLowerCase() === 'momentary time sample' ?
          <TableRowColumn width="20%">{obj.behaviorData + ' %'}</TableRowColumn>          
          :
          <TableRowColumn width="20%">{obj.behaviorData}</TableRowColumn> }         
        </TableRow>
      );
    });
  }

  handleAddDiagnosis = (formValues) => {
    let diseaseDetails = extractDataFromArray(this.state.master_data.masterICD, formValues.ICDID);
    let arr = this.state.diagnosisArray;
    if (arr.indexOf(formValues) === -1) {
      arr.push({
        'DiagnosisDate': moment(formValues.DiagnosisDate).format(),
        'Description': diseaseDetails.description,
        'ICDCodeId': diseaseDetails.id,
        'ICDCode': diseaseDetails.code,
        'IsDeleted': false,
        'Id': 0,
      });
      this.setState({ diagnosisArray: arr });
    }
  }
  handleAddCPT = (formValues) => {
    if (formValues.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: formValues.AuthProcedureCPTLinkId,
      //   actionName: 'Add',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let cptObj = extractDataFromArray(this.state.master_data.masterServiceCode, formValues.CPTID);
    let arr = this.state.CPTTableData;
    if (arr.indexOf(cptObj) === -1) {
      arr.push({
        'AuthProcedureCPTLinkId': formValues.AuthProcedureCPTLinkId,
        'AuthorizationNumber': formValues.AuthorizationNumber,
        'ServiceCodeId': cptObj.id,
        'ServiceCode': cptObj.serviceCode,
        'Description': cptObj.description,
        'IsDeleted': false,
        'Id': 0,
        'Modifier1': formValues.Modifier1 ? formValues.Modifier1 : null,
        'Modifier2': formValues.Modifier2 ? formValues.Modifier2 : null,
        'Modifier3': formValues.Modifier3 ? formValues.Modifier3 : null,
        'Modifier4': formValues.Modifier4 ? formValues.Modifier4 : null,
      });
      this.setState({ CPTTableData: arr });
    }
  }
  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    switch (formProps.Signee) {
      case 1:
        data.id = this.state.EmployeeSign.id || null;
        data.Name = extractNameFromArray(this.state.signatureStaffs, formProps.StaffID);
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ EmployeeSign: data });
        this.filter.isEmployeeSigned = true;
        this.saveEncounterSigns(data.id, data, null, null, null);
        break;
      case 2:
        data.id = this.state.ClientSign.id || null;
        data.Name = this.state.patientName;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ ClientSign: data });
        this.filter.isClientSigned = true;
        this.saveEncounterSigns(data.id, null, data, null, null);
        break;
      case 3:
        data.id = this.state.GuardianSign.id || null;
        data.Name = formProps.Guardian;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ GuardianSign: data });
        this.filter.isGuardianSigned = true;
        this.saveEncounterSigns(data.id, null, null, data, null);
        break;
      case 4:
        data.id = this.state.RenderingProviderSign.id || null;
        //data.Name = extractNameFromArray(this.state.signatureRenderingProviders, formProps.RenderingProviderID);
        data.Name = formProps.SupervisingClinician;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ RenderingProviderSign: data });
        this.filter.isRenderingProviderSigned = true;
        this.saveEncounterSigns(data.id, null, null, null, data);
        break;
      default:
        break;
    }

    this.setState({ isAllSigned: this.checkIsAllRequiredSigned() });
  }

  checkIsAllRequiredSigned() {
    let employee_Signed = true, client_signed = true, guardian_signed = true, rederingProvider_signed = true;
    if (this.state.signRequired.employee_sign) {
      if (this.filter.isEmployeeSigned) {
        employee_Signed = true;
      } else {
        employee_Signed = false;
      }
    }
    if (this.state.signRequired.client_sign && !this.state.appointmentTypeIsBillable) {
      if (this.filter.isClientSigned) {
        client_signed = true;
      } else {
        client_signed = false;
      }
    }
    if (this.state.signRequired.guardian_sign) {
      if (this.filter.isGuardianSigned) {
        guardian_signed = true;
      } else {
        guardian_signed = false;
      }
    }
    if (this.state.signRequired.rederingProvider_sign) {
      if (this.filter.isRenderingProviderSigned) {
        rederingProvider_signed = true;
      } else {
        rederingProvider_signed = false;
      }
    }
    // finally check if all required are signed ...
    if (employee_Signed && client_signed && guardian_signed && rederingProvider_signed) {
      return true;
    } else {
      return false;
    }
  }

  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign, renderingProviderSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      //staffId: renderingProviderSign ? this.state.renderingProviderID : null,
      renderingProviderName: renderingProviderSign ? renderingProviderSign.Name : null,
      renderingProviderSign: renderingProviderSign ? renderingProviderSign.Bytes : null,
      renderingProviderSignDate: renderingProviderSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      latitude: this.props.latitude ? this.props.latitude : 0.0,
      longitude: this.props.longitude ? this.props.longitude : 0.0,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  // componentDidUpdate() {
  //   if(this.state.isGenerateClaimAfterRendered)
  //   {     
  //     var link = document.getElementById('btnComplete');      
  //     if(link)      
  //       link.click();            
  //   }    
  // }

  handleSessionCheckboxChange = (e) => {
    const {name , checked} = e.target;
    this.setState((prevState) => ({
      selectedCheckBoxes :{
        ...prevState.selectedCheckBoxes,
        [name] : checked,
      }
    }))
  }

  handleFieldChange = (e) => {
    const {name , value} = e.target;
    this.setState((prevState) => ({
      TextFormFields : {
        ...prevState.TextFormFields,
        [name] : value
      }
    }));
  }

  handleGoalsForSessionCheckboxes = (e) => {
    const{name, checked} = e.target;
    this.setState((prevState) => ({
      GoalsForSessionCheckboxes :{
        ...prevState.GoalsForSessionCheckboxes,
        [name] : checked,
      }
    }));
  }

  handleDomainAddressedCheckboxes = (e) => {
    const{name, checked} = e.target;
    this.setState((prevState) => ({
      DomainAddressedCheckboxes: {
        ...prevState.DomainAddressedCheckboxes,
        [name] : checked,
      }
    }));
  }

  handleEvidenceBasedPracticesCheckboxes = (e) => {
    const {name, checked} = e.target;
    this.setState((prevState) => ({
      EvidenceBasedPracticesCheckboxes : {
        ...prevState.EvidenceBasedPracticesCheckboxes,
        [name] : checked,
      }
    }))
  }

  handleDSMRestrictedPatternOfBehaviorCheckboxes = (e) => {
    const{name, checked} = e.target;
    this.setState((prevState) => ({
      DSMRestrictedPatternOfBehaviorCheckboxes : {
        ...prevState.DSMRestrictedPatternOfBehaviorCheckboxes,
        [name] : checked,
      }
    }));
  }

  handleDSMSocialCommunicationCheckboxes = (e) => {
    const{name, checked} = e.target;
    this.setState((prevState) => ({
      DSMSocialCommunicationCheckboxes: {
        ...prevState.DSMSocialCommunicationCheckboxes,
        [name] : checked,
      }
    }));
  }

  handleBarriersToCommunicationCheckboxes = (e) => {
    const{name, checked} = e.target;
    this.setState((prevState) => ({
      BarriersToCommunicationCheckboxes : {
        ...prevState.BarriersToCommunicationCheckboxes,
        [name] : checked,
      }
    }));
  }

  handleNextStepsCheckboxes = (e) => {
    const{name, checked} = e.target;
    this.setState((prevState) => ({
      NextStepsCheckboxes : {
        ...prevState.NextStepsCheckboxes,
        [name] : checked,
      }
    }));
  }

  
  handleExpandRow = (Id) => {   
    let display = this.refs['expandedClass' + Id].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + Id].style.display = 'table-row';
      this.refs['expClass' + Id].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + Id].style.display = 'none';
      this.refs['expClass' + Id].className = 'classExpand fa fa-ellipsis-h';
    }
  }
  
  render() {
    const { handleSubmit } = this.props;
    const {selectedCheckBoxes, TypeOfObservation, TextFormFields, GoalsForSessionCheckboxes, DomainAddressedCheckboxes, EvidenceBasedPracticesCheckboxes,DSMRestrictedPatternOfBehaviorCheckboxes,  DSMSocialCommunicationCheckboxes, BarriersToCommunicationCheckboxes ,ProgressTowardsGoals, NextStepsCheckboxes} = this.state
    const isSessionCheckboxChecked = Object.values(selectedCheckBoxes).some(val => val === true);
    const isTextFilledValid = Object.values(TextFormFields).every(val => val.trim() !== '');
    const isGoalsForSessionChecked = Object.values(GoalsForSessionCheckboxes).some(val => val === true);
    const isDomainAddressedChecked = Object.values(DomainAddressedCheckboxes).some(val => val === true);
    const isEvidenceBasedPracticesChecked = Object.values(EvidenceBasedPracticesCheckboxes).some(val => val === true);
    const isDSMRestrictedPatternOfBehaviorChecked = Object.values(DSMRestrictedPatternOfBehaviorCheckboxes).some(val => val === true);
    const isDSMSocialCommunicationChecked = Object.values(DSMSocialCommunicationCheckboxes).some(val => val === true);
    const isBarriersToCommunicationCheckboxes = Object.values(BarriersToCommunicationCheckboxes).some(val => val === true);
    const isProgressTowardsGoals = ProgressTowardsGoals && ProgressTowardsGoals > 0 ? true : false;
    const isNextStepsCheckboxes = Object.values(NextStepsCheckboxes).some(val => val === true);
    const isFormValid = isSessionCheckboxChecked && (TypeOfObservation !== 0) && isTextFilledValid && isGoalsForSessionChecked && isDomainAddressedChecked && isEvidenceBasedPracticesChecked && isDSMRestrictedPatternOfBehaviorChecked && isDSMSocialCommunicationChecked && isProgressTowardsGoals && isNextStepsCheckboxes;
    // const tableClass = classNames({
    //   'table': true,
    //   'table-striped': this.props.bordered,
    //   'table-bordered': this.props.bordered,
    //   'table-hover': true,
    //   'table-condensed': this.props.condensed,
    //   'customtable': true,
    // });
    const handleGenerate = (e, index) => {
      Alert.warning('The summary data generated here will override the existing summary data.', {
        position: 'bottom-right',
        effect: 'slide',
        timeout: 10000,
        customFields: {
          displayComponent: true,
          handleButtonClick: handleSubmit(this.handleGenerateAISummary),
          id: index,
        },
      });
    }
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });
    let totalUnitsConsumed = (this.state.get_soap && this.state.get_soap.unitsConsumed) || 0;
    let canOnlyAddSignForTheirNotes = true;
    if (this.props.canOnlyAddSignForTheirNotes && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
      canOnlyAddSignForTheirNotes = this.props.currentLoginUserId === this.state.staffID;
    }
    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {this.state.patient_id ?
          <PatientInfo patientId={this.state.patient_id} />
          : ''}
        {this.state.open ?
          <ProblemModal soapPage={this.state.soapPage} diagnosisArray={this.state.diagnosisArray} master_data={this.state.master_data} closeDialog={this.handleClose} handleAddDiagnosis={this.handleAddDiagnosis} />
          : null}
        {this.state.openCPT ?
          <CPTModal soapPage={this.state.soapPage} patientId={this.state.patient_id} dateOfService={this.state.DateOfService} cptArray={this.state.CPTTableData} master_CPT={this.state.master_data.masterServiceCode ? this.state.master_data.masterServiceCode : this.props.master_data.masterServiceCode} closeDialog={this.handleCloseCPT} handleAddCPT={this.handleAddCPT} />
          : null}
        {this.state.openSign ?
            this.props.agencyName.toUpperCase() === 'TBC5' ?
            <SignatureModal staffID={this.state.staffID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />          
            :
            <SignatureWithRenderingProviderModal staffID={this.state.staffID} renderingProviderID={this.state.renderingProviderID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} renderingProviders={this.state.signatureRenderingProviders} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />                      
          : null}
        {this.state.openUploadDocument ? <UploadDocumentModal  uploadDocumentObj={this.state.uploadDocumentObj} closeDialog={this.handleCloseHandler}  PatientAppointmentId = {this.state.apptid} PatientEncounterId = {this.state.encounterId} /> : ''}      
        <div className="clearfix"></div>
        <div className="readmin-panel mt-15">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
             <div className="row">
             {this.state.isEvvPayer ? (
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '1vh',
                    textAlign: 'center'
                  }}>
                    <span style={{ color: "rgb(250,187,61)" }}>
                      This is an EVV Payer. Please render this session from the mobile app.
                    </span>
                  </div>
                ) : null}  
                <div className="col-8 col-sm-8 col-md-8">
                  {this.state.isGenerateClaimAfterRendered ?
                    <div className={'alert alert-danger-soap update-pwd'}>
                        <strong>**YOU MUST SCROLL DOWN AND CLICK ON THE COMPLETE BUTTON TO SAVE YOUR CHANGES. <br/> CHANGES MAY NOT BE SAVED UNLESS YOU CLICK COMPLETE! <br/> IF THERE IS NO COMPLETE BUTTON THEN YOUR CHANGES HAVE BEEN SAVED AUTOMATICALLY. **</strong>
                    </div>
                    : 
                    <CommonButton className="mb-20" label="Go back to scheduler" primary={true} onTouchTap={this.handleCancel} />
                   } 
                </div>
                <div className="col-2 col-sm-2 col-md-2 btn_rt">                                        
                  {(this.props.agencyName.toUpperCase() !== 'BASICS') && (!this.state.isEvvPayer) && (this.state.showClockInClockOut === "true") ?
                    <CommonButton className="mb-20" label="Clock In" disabled={this.state.clockInDateTime ? true : false} primary={true} onTouchTap={this.handleClockIn} />
                    : null}                                     
                </div>
                <div className="col-2 col-sm-2 col-md-2 btn_rt">                                        
                  {(this.props.agencyName.toUpperCase() !== 'BASICS') && !this.state.isEvvPayer && this.state.showClockInClockOut === "true" ?
                    <CommonButton className="mb-20" label="Clock Out" disabled={this.state.clockOutDateTime ? true : false} primary={true} onTouchTap={this.handleClockOut} />
                    : null}                                       
                </div>
              </div>
              <div className="row">                
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p>
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                      <p>
                        <b>Supervising Clinician Name :</b> <span>{this.state.renderingProviderName ? this.state.renderingProviderName : '-'}</span>
                      </p> 
                      <p>
                        <b>Session Duration (In Hrs):</b> <span>{this.state.timeDifference && this.state.timeDifference > 0 ? parseFloat((this.state.timeDifference/60).toFixed(2)) : 0.0}</span>
                      </p>
                      <p>
                        <b>Rendering Provider:</b><span>{this.state.claimRenderingProvider ? this.state.claimRenderingProvider : '-'}</span>
                      </p>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    fullWidth={true}
                    // disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    // disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceEndTime}
                    onDateChange={this.onDateChange}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Subjective</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    {/* <h5>Who was present in session?</h5>{this.state.isFormSubmitted ? <span style={{ color: 'red'}}>*</span> : null} */}
                    <h5>Who was present in session?</h5>{<span style={{ color: 'red'}}>*</span>}
                    {this.state.isFormSubmitted ? 
                    !this.state.isWhoWasPresentInSessionAllowed && !isSessionCheckboxChecked && <div  className='error' style={{marginLeft: '20px'}}>(Please select at least one)</div> : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehaviorTechnician"
                    label="Behavior Technician"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleSessionCheckboxChange}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Parent"
                    label="Parent"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleSessionCheckboxChange}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MidLevelSupervisor"
                    label="Mid-Level Supervisor"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleSessionCheckboxChange}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BCBA"
                    label="BCBA"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleSessionCheckboxChange}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Other"
                    label="Other"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleSessionCheckboxChange}
                  />
                </div>
                {this.props.selectorOther &&
                  (<div className={this.state.isFormSubmitted ? 'col-sm-4 require' : 'col-sm-4'}>
                  <Field
                    name="OtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                    validate={this.state.isFormSubmitted ? [validateOtherNotes] : null}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20">
                    {/* <h5>Type of Observation :</h5>{this.state.isFormSubmitted && <span style={{ color: 'red'}}>*</span>} */}
                    <h5>Type of Observation :</h5>{<span style={{ color: 'red'}}>*</span>}
                  </div>
                  <Field name="TypeOfObservation"
                    options={[{ id: 1, value: 'In-Person' }, { id: 2, value: 'Telehealth' }]}
                    selectedValue={this.state.TypeOfObservation}
                    onChange={this.changeIsTypeOfObservation}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCustomRadioButtons} 
                    validate={this.state.isFormSubmitted && this.state.TypeOfObservation === 0 ? [validateTypeOfObservation] : null}
                    />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    {/* <h5>How did people present participate</h5>{this.state.isFormSubmitted ? <span style={{ color: 'red'}}>*</span>:null} */}
                    <h5>How did people present participate</h5>{<span style={{ color: 'red'}}>*</span>}
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(i.e. Behavior technician conducted 1:1 direct therapy with the client. The parent assisted with redirection as needed. The BCBA conducted supervision)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="PeoplePresentParticipate"
                    type="text"
                    fullWidth={true}
                    //label="How did people present participate (i.e. Behavior technician conducted 1:1 direct therapy with the client. The parent assisted with redirection as needed. The BCBA conducted supervision)"
                    // autoHeight={true}
                    rows={8}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderTextArea}
                    onChange={this.handleFieldChange}
                    maxLength = {4000}
                    validate={this.state.isFormSubmitted ? [validatePeoplePresentParticipate] : null}
                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    {/* <h5>Setting Event(s) Reported</h5>{this.state.isFormSubmitted ? <span style={{ color: 'red'}}>*</span>:null} */}
                    <h5>Setting Event(s) Reported</h5>{<span style={{ color: 'red'}}>*</span>}
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(i.e. Client fell asleep at 12pm and woke up at 5am)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="SettingEventReported"
                    type="text"
                    fullWidth={true}
                    // label="Setting Event(s) Reported (i.e. Client fell asleep at 12pm and woke up at 5am)" 
                    // autoHeight={true}
                    rows={8}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderTextArea}
                    onChange={this.handleFieldChange}
                    maxLength = {4000}
                    validate={this.state.isFormSubmitted ? [validateSettingEventReported] : null}
                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Atypical Behaviors Reported</h5>{<span style={{ color: 'red'}}>*</span>}
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(i.e, The BCBA noted atypical behavior, client was eloping during session and running toward the bedroom)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="AtypicalBehaviorsReported"
                    type="text"
                    fullWidth={true}
                    //label="Atypical Behaviors Reported (i.e, The BCBA noted atypical behavior, client was eloping during session and running toward the bedroom)"
                    // autoHeight={true}
                    rows={8}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderTextArea}
                    onChange={this.handleFieldChange}
                    maxLength = {4000}
                    validate={this.state.isFormSubmitted ? [validateAtypicalBehaviorsReported] : null}

                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Client Response to Significant Others</h5>{<span style={{ color: 'red'}}>*</span>}
                  </div>
                </div>
                <div className="col-sm-12 font-italic">
                    <h6>(i.e. The client had delayed engagement with people present and required prompting to attend activities throughout the session)</h6>
                </div>
              </div>
              <div className ="row">                                
                <div className='col-sm-12 require'>
                  <Field
                    name="ClientResponseToSignificantOthers"
                    type="text"
                    fullWidth={true}
                    // label="Client Response to Significant Others (i.e. The client had delayed engagement with people present and required prompting to attend activities throughout the session)"
                    // autoHeight={true}
                    rows={8}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderTextArea}
                    onChange={this.handleFieldChange}
                    maxLength = {4000}
                    validate={this.state.isFormSubmitted ? [validateClientResponseToSignificantOthers] : null}
                    //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                  />
                </div>                
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Objective</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              {this.state.isDataCollectionEnabledForAgency && <div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-10 mb-10">
                    <h3 className="morebtn_form_h3">Skill Acquisition Data :</h3>
                    <button onClick={(e) => this.handleExpandRow(1)} type="button" className="morebtn morebtn_form">
                      <i ref={'expClass1'} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <i className="flaticon flaticon-interface-2"></i>                    
                  </div>
                </div>
              
              </div>
              <div className="table-responsive mt-15" ref={'expandedClass1'}  style={{ display: 'none' }}>
                <Table className={tableClass1}
                  height={this.state.dataCollectionHeight}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                        <TableHeaderColumn width="40%">Program Name</TableHeaderColumn>
                        <TableHeaderColumn width="40%">Target Name</TableHeaderColumn>
                        <TableHeaderColumn width="20%">Value</TableHeaderColumn>                      
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderSessionNotesSkillsAcquisition()}
                  </TableBody>
                </Table>
              </div>

              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-10 mb-10">
                    <h3 className="morebtn_form_h3">Behavior Reduction Data :</h3>
                    <button onClick={(e) => this.handleExpandRow(2)} type="button" className="morebtn morebtn_form">
                      <i ref={'expClass2'} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              
              </div>
              <div className="table-responsive mt-10 mb-40" ref={'expandedClass2'}   style={{ display: 'none' }}>
                <Table className={tableClass1}
                  height={this.state.dataCollectionHeight}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                        <TableHeaderColumn width="40%">Behavior Name</TableHeaderColumn>
                        <TableHeaderColumn width="40%">Recording Type </TableHeaderColumn>
                        <TableHeaderColumn width="20%">Value</TableHeaderColumn>                      
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderSessionNotesBehaviorReduction()}
                  </TableBody>
                </Table>
              </div>
            </div> }
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Goals for Session</h5>{<span style={{ color: 'red' }}>*</span>}
                    {this.state.isFormSubmitted && !isGoalsForSessionChecked ? !this.state.isGoalsForSessionAllowed && <div  className='error' style={{marginLeft: '20px'}}>(Please select at least one)</div> : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BuildRapport"
                    label="Build rapport with client ('pairing') with established reinforcers"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleGoalsForSessionCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillAcquisitionGoals"
                    label="Work on skill acquisition goals"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleGoalsForSessionCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GeneralizationOfSkillsOrBehaviors"
                    label="Work on generalization of skills or behaviors"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleGoalsForSessionCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MaintenanceGoals"
                    label="Work on maintenance goals"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleGoalsForSessionCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DecreasingMaladaptiveBehaviors"
                    label="Work on decreasing maladaptive behaviors"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleGoalsForSessionCheckboxes}
                  />
                </div>
                {/* <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherGoalsForSession"
                    label="Other"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherGoalsForSession &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherGoalsForSessionNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)} */}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Domains Addressed</h5>{<span style={{ color: 'red' }}>*</span>}
                    {this.state.isFormSubmitted && !isDomainAddressedChecked? !this.state.isDomainsAddressedAllowed && <div  className='error' style={{marginLeft: '20px'}}>(Please select at least one)</div> : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Behavior"
                    label="Behavior"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDomainAddressedCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Communication"
                    label="Communication"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDomainAddressedCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ExecutiveFunctioning"
                    label="Executive Functioning"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDomainAddressedCheckboxes}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialSkills"
                    label="Social Skills"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDomainAddressedCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AdaptiveSkills"
                    label="Adaptive Skills"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDomainAddressedCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="CommunityOrSafetySkills"
                    label="Community / Safety Skills"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDomainAddressedCheckboxes}
                  />
                </div>                
                {/* <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherDomainsAddressed"
                    label="Other"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherDomainsAddressed &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherDomainsAddressedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)} */}
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Evidence-Based Practices (Techniques) Utilized or Discussed </h5>{<span style={{ color: 'red' }}>*</span>}
                    {this.state.isFormSubmitted && !isEvidenceBasedPracticesChecked? !this.state.isEvidenceBasedPracticesAllowed && <div  className='error' style={{marginLeft: '20px'}}>(Please select at least one)</div>:null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AntecedentBasedIntervention"
                    label="Antecedent Based Intervention (ABI)"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DifferentialReinforcement"
                    label="Differential Reinforcement (DRO/DRA/DRI/DRL)"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DiscreteTrialTeaching"
                    label="Discrete Trial Teaching (DTT)"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Extinction"
                    label="Extinction"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FunctionalCommunicationTraining"
                    label="Functional Communication Training (FCT)"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Modeling"
                    label="Modeling"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IncidentalTeaching"
                    label="Incidental Teaching"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PivotalResponseTraining"
                    label="Pivotal Response Training (PRT)"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Prompting"
                    label="Prompting"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reinforcement"
                    label="Reinforcement"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ResponseInterruptionAndRedirection"
                    label="Response Interruption and Redirection (RIRD)"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialSkillsTraining"
                    label="Social Skills Training"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TaskAnalysis"
                    label="Task Analysis"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TimeDelay"
                    label="Time Delay"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Shaping"
                    label="Shaping"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="VisualSupports"
                    label="Visual Supports"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>               
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherEvidenceBasedPractices"
                    label="Other"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleEvidenceBasedPracticesCheckboxes}
                  />
                </div>
                {this.props.selectorOtherEvidenceBasedPractices &&
                (<div className={this.state.isFormSubmitted ? 'col-sm-4 require' : 'col-sm-4'}>
                  <Field
                    name="OtherEvidenceBasedPracticesNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                    validate={this.state.isFormSubmitted ? [validateOtherEvidenceBasedPracticesNotes] : null}
                  />
                </div>)}
              </div>


              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Assessment</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">                  
                    <h5>DSM-5 Deficits to Remediate: Restricted Patterns of Behavior</h5>{<span style={{ color: 'red' }}>*</span>}
                    {this.state.isFormSubmitted && !isDSMRestrictedPatternOfBehaviorChecked ? !this.state.isRestrictedPatternsOfBehaviorAllowed && <div  className='error' style={{marginLeft: '20px'}}>(Please select at least one)</div>: null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Motorstereotypies"
                    label="Motor stereotypies"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Stereotypieswithobjects"
                    label="Stereotypies with objects (lining up toys/flipping objects/etc)"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EcholaliaAndIdiosyncraticSpeech"
                    label="Echolalia and idiosyncratic speech"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ExtremeDistressAtSmallChange"
                    label="Extreme distress at small change"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DifficultiesWithTransition"
                    label="Difficulties with transition (needing to take the same route/or eat the same food)"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RigidGreetingRituals"
                    label="Rigid greeting rituals"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="StrongAttachmentsToPreoccupation"
                    label="Strong attachments to/or preoccupation with/unusual objects"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ExcessivelyCircumscribedOrPerseverativeInterests"
                    label="Excessively circumscribed or perseverative interests"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ApparentIndifferenceToPainOrTemperature"
                    label="Apparent indifference to pain or temperature"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AdverseResponseToSpecificSights"
                    label="Adverse response to specific sights/sounds/or textures"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="VisualFascinationWithLightsOrMovement"
                    label="Visual fascination with lights or movement"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherRestrictedPatternsOfBehavior"
                    label="Other"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMRestrictedPatternOfBehaviorCheckboxes}
                  />
                </div>
                {this.props.selectorOtherRestrictedPatternsOfBehavior &&
                (<div className={this.state.isFormSubmitted ? 'col-sm-4 require' : 'col-sm-4'}>
                  <Field
                    name="OtherRestrictedPatternsOfBehaviorNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                    validate={this.state.isFormSubmitted ? [validateOtherRestrictedPatternsOfBehaviorNotes] : null}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">                  
                    <h5>DSM-5 Deficits to Remediate: Social Communication / Interaction</h5>{<span style={{ color: 'red' }}>*</span>}
                    {this.state.isFormSubmitted && !isDSMSocialCommunicationChecked ? !this.state.isSocialCommunicationInteractionAllowed && <div  className='error' style={{marginLeft: '20px'}}>(Please select at least one)</div>:null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SharingOfInterests"
                    label="Deficits related to sharing of interests/emotions/or affect"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RespondingToSocialInteractions"
                    label="Deficits related to responding to social interactions/including increasing listening responses and verbal communication"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="InitiatingSocialInteractions"
                    label="Deficits related to initiating social interactions/including increasing verbal communication and intelligible speech"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BackAndForthConversations"
                    label="Deficits related to back and forth conversations"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SocialApproach"
                    label="Deficits related to social approach"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="NonverbalCommunication"
                    label="Deficits related to nonverbal communication"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IntegratingNonverbalAndVerbalCommunication"
                    label="Deficits related to integrating nonverbal and verbal communication"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EyeContactAndBodyLanguage"
                    label="Deficits related to eye contact and body language"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FacialExpression"
                    label="Deficits related to facial expression"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="UnderstandingAndUseOfGestures"
                    label="Deficits related to understanding and use of gestures"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SharingImaginativePlay"
                    label="Deficits related to sharing imaginative play"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div> 
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MakingFriends"
                    label="Deficits related to making friends"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IncreasingInterestInPeer"
                    label="Deficits related to increasing interest in peer"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherSocialCommunication"
                    label="Other"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleDSMSocialCommunicationCheckboxes}
                  />
                </div>                
                {this.props.selectorOtherSocialCommunication &&
                (<div className={this.state.isFormSubmitted ? 'col-sm-4 require' : 'col-sm-4'}>
                  <Field
                    name="OtherSocialCommunicationNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                    validate={this.state.isFormSubmitted ? [validateOtherSocialCommunicationNotes] : null}
                  />
                </div>)}
              </div>
              {this.props.appConfigAIGenerateSetting && this.props.appConfigAIGenerateSetting.value === 'true' ?(
                <div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="panel_title">
                        {/* <h5>Narrative Summary</h5>{this.state.isFormSubmitted ? <span style={{ color: 'red'}}>*</span>:null} */}
                        <h5>Narrative Summary</h5>{<span style={{ color: 'red'}}>*</span>}
                      </div>
                    </div>
                    <div className="col-sm-12 font-italic">
                        <h6>(Write a general summary of the session which includes activities conducted for specific skill acquisition and/or behavior reduction targets)</h6>
                    </div>
                  </div>
                  <div className ="row">                                
                    <div className='col-sm-12 require'>
                      <Field
                        name="NarrativeSummary"
                        type="text"
                        fullWidth={true}
                        //label="Narrative Summary (Write a general summary of the session which includes activities conducted for specific skill acquisition and/or behavior reduction targets)"
                        // autoHeight={true}
                        rows={8}
                        disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                        component={renderTextArea}
                        maxLength="4000"
                        validate={this.state.isFormSubmitted ? [validateNarrativeSummary] : null}
                        //validate={this.state.appointmentTypeIsBillable === true ? [validateNotes] : null}
                      />
                    </div>                
                  </div>
                </div>)
              : null}
              <div className='row'>
                <div className='col-sm-12 pdl-30'>
                  {this.props.appConfigAIGenerateSetting && this.props.appConfigAIGenerateSetting.value === 'true' ? (
                    <div>
                      {!isFormValid && this.props.initialValues === null &&this.state.isTooltipVisible && (
                        <Tooltip 
                          label="Please fill in all mandatory fields above" 
                          show={true} 
                          style={{ position: 'absolute', top: '-10px' }}
                        />
                      )}
                      <RaisedButton
                        className="soapmodal_btn ml-3"
                        label={this.state.isGeneratingNarrativeSummary ? "Generating..." : "Generate AI summary"}
                        disabled={(!isFormValid) || this.state.isSoapCompleted || this.state.isSessionPending}                        
                        // disabled={!isFormValid}
                        onMouseEnter={this.handleMouseEnter}  
                        onMouseLeave={this.handleMouseLeave}  
                        backgroundColor="#09a9dc"  
                        labelColor="#ffffff"  
                        onTouchTap={this.props.isGeneratingNarrativeSummary !== undefined || (this.props.initialValues && this.props.initialValues.NarrativeSummary !== null)? handleSubmit(handleGenerate) : handleSubmit(this.handleGenerateAISummary)}                      
                      />
                  </div>
                  ) : null}
                </div>  
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">                  
                    <h5>Barriers to Treatment</h5>{this.state.isFormSubmitted ? <span style={{ color: 'red' }}>*</span>: null}
                    {this.state.isFormSubmitted && !isBarriersToCommunicationCheckboxes ? !this.state.isBarriersToTreatmentAllowed && <div  className='error' style={{marginLeft: '20px'}}>(Please select at least one)</div> : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Inattentiveness"
                    label="Inattentiveness"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Hyperactivity"
                    label="Hyperactivity"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="HighRateOfMaladaptiveBehaviors"
                    label="High rate of maladaptive behaviors"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ScrollingResponses"
                    label="Scrolling responses"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RatioStrain"
                    label="Ratio strain"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ReinforcerDependent"
                    label="Reinforcer dependent"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PromptDependence"
                    label="Prompt dependence"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="HighRateOfSelfStimulatoryBehavior"
                    label="High rate of self-stimulatory behavior"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="MotivationWeakenedByResponseRequirement"
                    label="Motivation weakened by response requirement"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SensoryDefensiveness"
                    label="Sensory defensiveness"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObsessiveCompulsiveBehavior"
                    label="Obsessive-compulsive behavior"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>                        
                <div className='col-sm-6 mt-35'>
                  <Field
                    name="OtherBarriersToTreatment"
                    label="Other"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleBarriersToCommunicationCheckboxes}
                  />
                </div>
                {this.props.selectorOtherBarriersToTreatment &&
                (<div className={this.state.isFormSubmitted ? 'col-sm-6 require' : 'col-sm-6'}>
                  <Field
                    name="OtherBarriersToTreatmentNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                    validate={this.state.isFormSubmitted ? [validateOtherBarriersToTreatmentNotes] : null}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20">
                    <h5>Progress Towards Goals and Outcome of Treatment :</h5>{<span style={{ color: 'red'}}>*</span>}
                  </div>
                  <Field name="ProgressTowardsGoals"
                    options={[{ id: 1, value: 'Exceeding - The client is making exceptional progress towards mastering skill acquisition treatment goals or objectives and/or showing a decrease in maladaptive behaviors.' }, 
                              { id: 2, value: 'As Expected - The client is making progress as expected towards mastering skill acquisition treatment goals or objectives and/or showing a decrease in maladaptive behaviors.' }, 
                              { id: 3, value: 'Delayed - The client is making delayed progress towards mastering skill acquisition treatment goals or objectives and/or showing an increase in maladaptive behaviors due to barriers to treatment.' }]}
                    selectedValue={this.state.ProgressTowardsGoals}
                    onChange={this.changeIsProgressTowardsGoals}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCustomRadioButtons} 
                    validate={this.state.isFormSubmitted && this.state.ProgressTowardsGoals === 0 ? [validateProgressTowardsGoals] : null}
                    />
                </div>
              </div>      


              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Plan</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">                  
                    <h5>What are the next steps?</h5>{<span style={{ color: 'red' }}>*</span>}
                    {this.state.isFormSubmitted && !isNextStepsCheckboxes ? !this.state.isWhatAreTheNextStepsAllowed && <div  className='error' style={{marginLeft: '20px'}}>(Please select at least one)</div>: null} 
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-6 mt-35'>
                  <Field
                    name="ContinueWithProgramming"
                    label="Continue with programming as directed by the clinical team"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleNextStepsCheckboxes}
                  />
                </div>
                <div className='col-sm-6 mt-35'>
                  <Field
                    name="DiscussProgramProgress"
                    label="Discuss program progress with the clinical team"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleNextStepsCheckboxes}
                  />
                </div>                                    
                <div className='col-sm-6 mt-35'>
                  <Field
                    name="OtherNextSteps"
                    label="Other"
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderCheckBox}
                    onChange={this.handleNextStepsCheckboxes}
                  />
                </div>
                {this.props.selectorOtherNextSteps &&
                (<div className={this.state.isFormSubmitted ? 'col-sm-6 require' : 'col-sm-6'}>
                  <Field
                    name="OtherNextStepsNotes"
                    type="text"
                    fullWidth={true}
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                    validate={this.state.isFormSubmitted ? [validateOtherNextStepsNotes] : null}
                  />
                </div>)}
              </div>
            
            </form>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3 className="morebtn_form_h3">Diagnosis</h3>
                  <button onClick={(e) => this.handleExpandRow(3)} type="button" className="morebtn morebtn_form">
                      <i ref={'expClass3'} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                  <i className="flaticon flaticon-gym"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <CommonButton className="soapmodal_btn" label="Add Diagnosis" primary={true} onTouchTap={this.handleOpen} />
                </div>
                : null} */}
            </div>
            <div className="table-responsive mt-15" ref={'expandedClass3'}   style={{ display: 'none' }}>
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                    <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    {/* {!this.state.isSoapCompleted ?
                      <TableHeaderColumn>Action</TableHeaderColumn>
                      : null} */}
                    {/* <TableHeaderColumn width="20%">Attach</TableHeaderColumn>*/}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderDiagnosis()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3 className="morebtn_form_h3">Service Codes</h3>
                  <button onClick={(e) => this.handleExpandRow(4)} type="button" className="morebtn morebtn_form">
                      <i ref={'expClass4'} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                  <i className="flaticon flaticon-interface-2"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <RaisedButton className="soapmodal_btn" label="Add Service Codes" primary={true} onTouchTap={this.handleOpenCPT} />
                </div>
                : null} */}
            </div>
            <div className="mt-15" ref={'expandedClass4'}   style={{ display: 'none' }}>
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn>Service Code</TableHeaderColumn>
                    <TableHeaderColumn>Modifiers</TableHeaderColumn>
                    <TableHeaderColumn>Description</TableHeaderColumn>
                    {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
                      <TableHeaderColumn width="10%">Action</TableHeaderColumn>
                      : null} */}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderCpt()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className={`col-sm-12 pt20 btn_rt ${this.state.showCompleteButton && 'scroll_btn'}`}>
                <CancelButton onTouchTap={this.handleCancel} />
                {this.state.showCompleteButton && canOnlyAddSignForTheirNotes ?
                  <CommonButton className="soapmodal_btn ml-3" label="Upload Documents" primary={true} onTouchTap={this.uploadDocumenthandler} />
                : ''}
                {this.state.showCompleteButton && canOnlyAddSignForTheirNotes ?
                  <CommonButton className="soapmodal_btn ml-3" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  : ''}

                {!this.state.isSoapCompleted && !this.state.IsHideOnlyCompleteButton ?
                  (<span>
                    {!this.state.showCompleteButton && <CommonButton id="btnSaveAsDraft" onClick={handleSubmit(this.onSaveAsDraft)} className="ml-3" primary={true} label="Save As Draft" />}
                    {this.state.showCompleteButton && this.state.appointmentTypeIsBillable ?
                      <CommonButton id="btnComplete" className="ml-3 soapmodal_btn" label="Complete" primary={true} disabled={!this.state.isAllSigned} onClick={this.state.isEvvPayer ? this.handleOpenConfirmationPopUpModal : handleSubmit(this.onCompleteSoap)} />
                      :
                      <CommonButton id="btnSave" onClick={handleSubmit(this.onSubmit)} className="ml-3" primary={true} label="Save" />
                    }
                  </span>)
                  : ''}
              </div>
            </div>
            
            {
                this.state.openRenderModal && <ConfirmationPopUpModal formProps = {this.formPropDataPusher} closeDialog={this.handleClose} sendReason = {this.reasonCodeGetter}  noteDataGetter = {this.noteDataGetter} onCompleteSoap = {handleSubmit(this.onCompleteSoap)}  isAdminUpdateAfterRendered ={this.state.isAdminUpdateAfterRendered}  apptid={this.state.apptid}   encounterId={this.state.encounterId} />
              }

            {this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
              <div className="row">
                <div className="col-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Signature</h3>
                    <i className="flaticon flaticon-medical-1"></i>
                  </div>
                </div>
                {
                  this.state.EmployeeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                              <h3>{this.state.EmployeeSign.Name} {this.props.agencyName.toUpperCase() === ABCSPECTRUM ? <span>(Practitioner)</span> : <span>(Employee)</span>}</h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name ? this.state.ClientSign.Name : this.state.patientName} <span>(BCBA)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
              </div>
              : ''}

          </div>
        </div>
      </div>
    );
  }
};
const selector = formValueSelector('soapForm');
SessionNotes_BT_Default = reduxForm({
  form: 'soapForm',
  //validate,
  enableReinitialize: true,
})(SessionNotes_BT_Default);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_ADDCODES_IN_SOAP')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_DELETECODES_IN_SOAP')[0].permission : false;
  let modifyAfterRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_MODIFYAPPOINTMENT_AFTER_RENDERING')[0].permission : false;
  let requiredGuardianSignForIndirectServicePermission = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_REQUIRED_GUARDIAN_SIGNATURE_FOR_INDIRECT_SERVICE')[0].permission : false;
  let canOnlyAddSignForTheirNotes = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_PRACTITIONER_CAN_ONLY_ADD_SIGN_FOR_THEIR_OWN_NOTES')[0].permission : false;
  // End For Role Permission

  let app_config = state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null;
  let appConfigAIGenerateSetting = [];
  if (state.appConfig.appConfigList && state.appConfig.appConfigList.data && state.appConfig.appConfigList.data.length) {
    appConfigAIGenerateSetting = state.appConfig.appConfigList.data.find(data => data.key === 'GEN_AI_NARRATIVE_SUMMARY');
  }
  let initialData = null;
  if (state.soap.get_soap) {
    let obj = state.soap.get_soap.data;
    if (obj.sessionNotes_BT_Default) {
      initialData = {        
        PeoplePresentParticipate: obj.sessionNotes_BT_Default.peoplePresentParticipate,
        SettingEventReported: obj.sessionNotes_BT_Default.settingEventReported,
        AtypicalBehaviorsReported: obj.sessionNotes_BT_Default.atypicalBehaviorsReported,
        ClientResponseToSignificantOthers: obj.sessionNotes_BT_Default.clientResponseToSignificantOthers,

        // BT_Default_Subjective
        BehaviorTechnician: obj.sessionNotes_BT_Default.bT_Default_Subjective[0] ? obj.sessionNotes_BT_Default.bT_Default_Subjective[0].behaviorTechnician : null,
        Parent: obj.sessionNotes_BT_Default.bT_Default_Subjective[0] ? obj.sessionNotes_BT_Default.bT_Default_Subjective[0].parent : null,
        MidLevelSupervisor: obj.sessionNotes_BT_Default.bT_Default_Subjective[0] ? obj.sessionNotes_BT_Default.bT_Default_Subjective[0].midLevelSupervisor : null,
        BCBA: obj.sessionNotes_BT_Default.bT_Default_Subjective[0] ? obj.sessionNotes_BT_Default.bT_Default_Subjective[0].bcba : null,
        Other: obj.sessionNotes_BT_Default.bT_Default_Subjective[0] ? obj.sessionNotes_BT_Default.bT_Default_Subjective[0].other : null,
        OtherNotes: obj.sessionNotes_BT_Default.bT_Default_Subjective[0] ? obj.sessionNotes_BT_Default.bT_Default_Subjective[0].otherNotes : null,
        TypeOfObservation: obj.sessionNotes_BT_Default.bT_Default_Subjective[0] ? (obj.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation === 1 ? 1 : (obj.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation === 2 ? 2 : 0)) : 0,

        // BT_Default_Objective
        BuildRapport: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].buildRapport : null,
        SkillAcquisitionGoals: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].skillAcquisitionGoals : null,
        GeneralizationOfSkillsOrBehaviors: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].generalizationOfSkillsOrBehaviors : null,
        MaintenanceGoals: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].maintenanceGoals : null,
        DecreasingMaladaptiveBehaviors: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].decreasingMaladaptiveBehaviors : null,
        // OtherGoalsForSession: obj.sessionNotes_BT_Default.bT_Default_Objective[0].otherGoalsForSession,
        // OtherGoalsForSessionNotes: obj.sessionNotes_BT_Default.bT_Default_Objective[0].otherGoalsForSessionNotes,

        Behavior: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].behavior : null,
        Communication: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].communication : null,
        ExecutiveFunctioning: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].executiveFunctioning : null,
        SocialSkills: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].socialSkills : null,
        AdaptiveSkills: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].adaptiveSkills : null,
        CommunityOrSafetySkills: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].communityOrSafetySkills : null,
        // OtherDomainsAddressed: obj.sessionNotes_BT_Default.bT_Default_Objective[0].otherDomainsAddressed,
        // OtherDomainsAddressedNotes: obj.sessionNotes_BT_Default.bT_Default_Objective[0].otherDomainsAddressedNotes,

        AntecedentBasedIntervention: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].antecedentBasedIntervention : null,
        DifferentialReinforcement: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].differentialReinforcement : null,
        DiscreteTrialTeaching: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].discreteTrialTeaching : null,
        Extinction: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].extinction : null,
        FunctionalCommunicationTraining: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].functionalCommunicationTraining : null,
        Modeling: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].modeling : null,
        IncidentalTeaching: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].incidentalTeaching : null,
        PivotalResponseTraining: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].pivotalResponseTraining : null,
        Prompting: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].prompting : null,
        Reinforcement: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].reinforcement : null,
        ResponseInterruptionAndRedirection: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].responseInterruptionAndRedirection : null,
        SocialSkillsTraining: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].socialSkillsTraining : null,
        TaskAnalysis: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].taskAnalysis : null,
        TimeDelay: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].timeDelay : null,
        Shaping: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].shaping : null,
        VisualSupports: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].visualSupports : null,
        OtherEvidenceBasedPractices: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].otherEvidenceBasedPractices : null,
        OtherEvidenceBasedPracticesNotes: obj.sessionNotes_BT_Default.bT_Default_Objective[0] ? obj.sessionNotes_BT_Default.bT_Default_Objective[0].otherEvidenceBasedPracticesNotes : null,

        // BT_Default_Assessment
        Motorstereotypies: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].motorstereotypies : null,
        Stereotypieswithobjects: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].stereotypieswithobjects : null,
        EcholaliaAndIdiosyncraticSpeech: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].echolaliaAndIdiosyncraticSpeech : null,
        ExtremeDistressAtSmallChange: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].extremeDistressAtSmallChange : null,
        DifficultiesWithTransition: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].difficultiesWithTransition : null,
        RigidGreetingRituals: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].rigidGreetingRituals : null,
        StrongAttachmentsToPreoccupation: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].strongAttachmentsToPreoccupation : null,
        ExcessivelyCircumscribedOrPerseverativeInterests: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].excessivelyCircumscribedOrPerseverativeInterests : null,
        ApparentIndifferenceToPainOrTemperature: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].apparentIndifferenceToPainOrTemperature : null,
        AdverseResponseToSpecificSights: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].adverseResponseToSpecificSights : null,
        VisualFascinationWithLightsOrMovement: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].visualFascinationWithLightsOrMovement : null,
        OtherRestrictedPatternsOfBehavior: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].otherRestrictedPatternsOfBehavior : null,
        OtherRestrictedPatternsOfBehaviorNotes: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].otherRestrictedPatternsOfBehaviorNotes : null,

        SharingOfInterests: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].sharingOfInterests : null,
        RespondingToSocialInteractions: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].respondingToSocialInteractions : null,
        InitiatingSocialInteractions: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].initiatingSocialInteractions : null,
        BackAndForthConversations: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].backAndForthConversations : null,
        SocialApproach: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].socialApproach : null,
        NonverbalCommunication: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].nonverbalCommunication : null,
        IntegratingNonverbalAndVerbalCommunication: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].integratingNonverbalAndVerbalCommunication : null,
        EyeContactAndBodyLanguage: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].eyeContactAndBodyLanguage : null,
        FacialExpression: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].facialExpression : null,
        UnderstandingAndUseOfGestures: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].understandingAndUseOfGestures : null,
        SharingImaginativePlay: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].sharingImaginativePlay : null,
        MakingFriends: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].makingFriends : null,
        IncreasingInterestInPeer: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].increasingInterestInPeer : null,
        OtherSocialCommunication: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].otherSocialCommunication : null,
        OtherSocialCommunicationNotes: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].otherSocialCommunicationNotes : null,

        NarrativeSummary: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].narrativeSummary : '',
        Inattentiveness: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].inattentiveness : '',
        
        Hyperactivity: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].hyperactivity : null,
        HighRateOfMaladaptiveBehaviors: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].highRateOfMaladaptiveBehaviors : null,
        ScrollingResponses: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].scrollingResponses : null,
        RatioStrain: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].ratioStrain : null,
        ReinforcerDependent: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].reinforcerDependent : null,
        PromptDependence: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].promptDependence : null,
        HighRateOfSelfStimulatoryBehavior: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].highRateOfSelfStimulatoryBehavior : null,
        MotivationWeakenedByResponseRequirement: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].motivationWeakenedByResponseRequirement : null,
        SensoryDefensiveness: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].sensoryDefensiveness : null,
        ObsessiveCompulsiveBehavior: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].obsessiveCompulsiveBehavior : null,
        OtherBarriersToTreatment: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].otherBarriersToTreatment : null,
        OtherBarriersToTreatmentNotes: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? obj.sessionNotes_BT_Default.bT_Default_Assessment[0].otherBarriersToTreatmentNotes : null,

        ProgressTowardsGoals: obj.sessionNotes_BT_Default.bT_Default_Assessment[0] ? (obj.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 1 ? 1 : (obj.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 2 ? 2 : (obj.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 3 ? 3 : 0))) : 0,

        // BT_Default_Plan
        ContinueWithProgramming: obj.sessionNotes_BT_Default.bT_Default_Plan[0] ? obj.sessionNotes_BT_Default.bT_Default_Plan[0].continueWithProgramming : null,
        DiscussProgramProgress: obj.sessionNotes_BT_Default.bT_Default_Plan[0] ? obj.sessionNotes_BT_Default.bT_Default_Plan[0].discussProgramProgress : null,
        OtherNextSteps: obj.sessionNotes_BT_Default.bT_Default_Plan[0] ? obj.sessionNotes_BT_Default.bT_Default_Plan[0].otherNextSteps : null,
        OtherNextStepsNotes: obj.sessionNotes_BT_Default.bT_Default_Plan[0] ? obj.sessionNotes_BT_Default.bT_Default_Plan[0].otherNextStepsNotes : null,
        
      };
    }
  }

  return {
    
    selectorOther: selector(state, 'Other'),
    selectorOtherEvidenceBasedPractices: selector(state, 'OtherEvidenceBasedPractices'),
    selectorOtherBarriersToTreatment: selector(state, 'OtherBarriersToTreatment'),
    selectorOtherNextSteps: selector(state, 'OtherNextSteps'),
    selectorOtherGoalsForSession: selector(state, 'OtherGoalsForSession'),
    selectorOtherDomainsAddressed: selector(state, 'OtherDomainsAddressed'),
    selectorOtherRestrictedPatternsOfBehavior: selector(state, 'OtherRestrictedPatternsOfBehavior'),
    selectorOtherSocialCommunication: selector(state, 'OtherSocialCommunication'),

    app_config: app_config,
    userLocationList: state.login.userLocationList,
    master_data: state.soap.master_data,
    patientData: state.patient.get_patient_byid,
    patientPrimaryDiagnosis: state.patient.patientPrimaryDiagnosis,

    loading: state.soap.loading || state.customSoap.loading,
    appointment: state.soap.appointment,
    get_soap: state.soap.get_soap,
    saved_soap: state.soap.saved_soap && state.soap.saved_soap.data ? state.soap.saved_soap.data : null,
    initialValues: initialData,
    currentLoginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    hasDefaultAccess: hasDefaultAccess,
    addPermission: addPermission,
    deletePermission: deletePermission,
    modifyAfterRenderPermission: modifyAfterRenderPermission,
    requiredGuardianSignForIndirectServicePermission: requiredGuardianSignForIndirectServicePermission,
    canOnlyAddSignForTheirNotes: canOnlyAddSignForTheirNotes,
    latitude: state.appConfig.latitude,
    longitude: state.appConfig.longitude,
    clockInLatitude: state.appConfig.clockInLatitude,
    clockInLongitude: state.appConfig.clockInLongitude,
    clockOutLatitude: state.appConfig.clockOutLatitude,
    clockOutLongitude: state.appConfig.clockOutLongitude,    
    TypeOfObservation: (state.soap.get_soap && state.soap.get_soap.data && state.soap.get_soap.data.sessionNotes_BT_Default && state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Subjective[0] && state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation >= 0 ? (state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation === 1 ? 1 : (state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Subjective[0] && state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Subjective[0].typeOfObservation === 2 ? 2 : 0)) : 0),
    ProgressTowardsGoals: (state.soap.get_soap && state.soap.get_soap.data && state.soap.get_soap.data.sessionNotes_BT_Default && state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Assessment[0] && state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals >= 0 ? state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 1 ? 1 : (state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Assessment[0] && state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 2 ? 2 : (state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Assessment[0] && state.soap.get_soap.data.sessionNotes_BT_Default.bT_Default_Assessment[0].progressTowardsGoals === 3 ? 3 : 0)) : 0),
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    appConfigAIGenerateSetting,
    narrativeAISummaryResponse: state.soap.narrativeAISummaryResponse,
    narrativeAISummaryError: state.soap.narrativeAISummaryError,
    isGeneratingNarrativeSummary: state.soap.isGeneratingNarrativeSummary,
    previousLocation: state.scheduling.previousLocation
  };
}

export default connect(mapStateToProps, { getMasterData, getSoapAction, createClaimAction, getAppointmentById, savePatientSoapExtensionAction, updateServiceCodeBlockedUnits, getAppConfigList, getPatientProfileDetails, saveEncounterSigns, getGeoLocation, getGeoLocationClockIn, getGeoLocationClockOut, saveClockInTimeIntoAppointment, saveClockOutTimeIntoAppointment,savePatientSoapAction, generateNarrativeSummary, change, clearNarrativeSummary })(SessionNotes_BT_Default);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/soap/SessionNotes_BT_Default.js